
import {
    Autocomplete,
    Avatar,
    Backdrop,
    Badge,
    Box,
    Button,
    Card,
    CardHeader,
    Checkbox,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    FormControlLabel,
    Grid,
    IconButton,
    ImageList,
    ImageListItem,
    ImageListItemBar,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Paper,
    Stack,
    Switch,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Tooltip,
    Typography,
    useMediaQuery,
    makeStyles,
    Skeleton,
    Chip,
  } from '@material-ui/core'
  import Page from '../../components/Page'
  import { capitalCase, sentenceCase } from 'change-case'
  import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
  import trash2Outline from '@iconify/icons-eva/trash-2-outline'
  import lockOpenFill from '@iconify/icons-ph/lock-open-fill'
  import editFill from '@iconify/icons-eva/edit-fill'
  import plusFill from '@iconify/icons-eva/plus-fill'  //materail
  import checkmarkFill from '@iconify/icons-eva/checkmark-fill'
  import * as Yup from 'yup'
  import { Form, FormikProvider, useFormik } from 'formik'
  import { alpha, experimentalStyled as styled } from '@material-ui/core/styles'
  import { useTheme } from '@material-ui/core/styles'
  import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs'
  import Label from 'src/components/Label'
  import { useLocation, useNavigate, useParams } from 'react-router'
  import { forwardRef, useEffect, useMemo, useRef, useState } from 'react'
  import PublicMsgBoard from 'src/components/_dashboard/official-request/PublicMsgBoard'
  import RequestTabUpdates from 'src/components/_dashboard/user/account/RequestTabUpdates'
  import PublicMessageBoard from 'src/components/_dashboard/user/profile/PublicMessageBoard.js'
  import RequestUpdates from 'src/components/_dashboard/official-request/RequestUpdates'
  import PaymentRequest from 'src/components/_dashboard/official-request/PaymentRequest'
  import JobNoteWindow from 'src/components/_dashboard/chat/JobNoteWindow'
  import {
    AddCircle,
    BlockOutlined,
    Delete,
    KeyboardBackspaceOutlined,
    Print,
    LocationOn,
    Add,
    Remove,
    CenterFocusStrong,
    NoteAdd,
    AddCircleOutlined,
    PictureAsPdf,
  } from '@material-ui/icons'
  import Modal from 'src/components/_dashboard/blog/ProjectModel'
  import Icon from '@iconify/react'
  import Scrollbar from 'src/components/Scrollbar'
  import axios from 'axios'
  import {
    currentFacilityId,
    FacilityTypes,
    filteredOtherFacilityTypes,
    REST_API,
    REST_API_END_POINT,
    SEND_EMAIL,
    UNITS,
  } from 'src/constants/Defaultvalues'
  import moment from 'moment'
  import { PATH_DASHBOARD } from 'src/routes/paths'
  import { useSnackbar } from 'notistack'
  import { LoadingButton, MobileDatePicker } from '@material-ui/lab'
  import { useCallback } from 'react'
  import { UploadAvatar, UploadMultiFile } from 'src/components/upload'
  import AddClients from 'src/components/_dashboard/official-request/AddClients'
  import AddProposal from 'src/components/_dashboard/official-request/AddProposal'
  import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup'
  import ReactToPrint from 'react-to-print'
  import { storage } from '../../firebase/firebase'
  import {
    getDownloadURL,
    ref as imageref,
    uploadBytesResumable,
  } from 'firebase/storage'
  import { Link } from 'react-router-dom'
  import { empty } from 'src/Helpers/Common'
  import Locations from 'src/components/_dashboard/official-request/Locations'
  import Workflow from 'src/components/_dashboard/general-analytics/RfqForm'
  import { AccountNotifications } from '../../components/_dashboard/user/account'
  import { set } from 'lodash'
  import Proposals from 'src/components/_dashboard/official-request/Proposals'
  import useCompanyProfile from 'src/hooks/useCompanyProfile'
  import LoadingScreen from 'src/components/LoadingScreen'
  import PrintableContent from './printPreview'
  import { red } from '@material-ui/core/colors'
  import AnimatedButton from 'src/components/animate/AnimatedButton'
  import ViewDesignOrderDetails from 'src/components/_dashboard/official-request/ViewDesignOrderDetails'
  import { DialogAnimate } from 'src/components/animate'
  import filePdfIcon from '@iconify/icons-mdi/file-pdf';
  import emailFillIcon from '@iconify/icons-eva/email-fill';
  import arrowLeftOutlined from '@iconify/icons-ant-design/arrow-left-outlined';
  import arrowRightOutlined from '@iconify/icons-ant-design/arrow-right-outlined';
  import { supabase } from '../../supabase/supabaseClient';
import ViewSplitEstimateDetails from 'src/components/_dashboard/official-request/ViewSplitEstimateDetails'
import SendDesignsEmailModal from 'src/components/_dashboard/official-request/SendDesignsEmailModal';
import { isAdminUser } from '../../utils/adminUserTypes';
import JobCost from './receipe'
import AddProducts from 'src/components/_dashboard/blog/AddProducts'
  
  const RowResultStyle = styled(TableRow)(({ theme }) => ({
    '& td': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  }))
  const MAX_CHARACTERS = 100
  
  const getStatusColorAndLabel = (status, hold) => {
    switch (status) {
      case 1:
        return {
          color: hold == 1 ? 'warning' : 'info',
          label: hold == 1 ? 'Status: Hold' : 'Status: Open',
        }
      case 2:
        return {
          color: hold == 1 ? 'warning' : 'success',
          label: hold == 1 ? 'Status: Hold' : 'Status: Approved',
        } // Evaluating
      case 3:
        return {
          color: hold == 1 ? 'warning' : 'error',
          label: hold == 1 ? 'Status: Hold' : 'Status: Rejected',
        }
      case 4:
        return {
          color: hold == 1 ? 'warning' : 'success',
          label: hold == 1 ? 'Status: Hold' : 'Status: Converted',
        }
      case 5:
        return {
          color: hold == 1 ? 'warning' : 'success',
          label: hold == 1 ? 'Status: Hold' : 'Status: Products Added Successfully',
        }
      case 6:
        return {
          color: hold == 1 ? 'warning' : 'error',
          label: hold == 1 ? 'Status: Hold' : 'Status: Rejected',
        }
      default:
        return {
          color: hold == 1 ? 'warning' : 'default',
          label: hold == 1 ? 'Status: Hold' : 'Status: Open',
        }
    }
  }
  
  const VALUE_SERVICES = [
    // { id: 0, value: 'Product Sl No.' },
    { id: 1, value: 'Service Name' },
    { id: 2, value: 'Markup (%)' },
    { id: 3, value: 'Cost (Hourly)' },
    { id: 4, value: 'Markup Cost (Hourly)' },
    { id: 5, value: 'Hours' },
    // { id: 6, value: 'Location' },
    { id: 7, value: 'Product Formula Cost' },
    { id: 8, value: 'Additional Cost' },
    { id: 9, value: 'Total cost' },
    { id: 10, value: '' },
  ]
  
  const useStyles = makeStyles((theme) => ({
    attachmentBox: {
      cursor: 'pointer',
      display: 'flex',
      borderRadius: '6px',
      backgroundColor: '#172e34',
      padding: theme.spacing(1),
      margin: theme.spacing(1, 0),
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      height: '100px',
      overflow: 'hidden',
    },
    attachmentIcon: {
      marginRight: theme.spacing(1),
    },
    delete: {
      m: 2,
      display: 'flex',
      justifyContent: 'flex-end',
    },
    checkbox: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
    },
    checkboxContainer: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
    },
    dialogContent: {
      padding: theme.spacing(3),
      maxWidth: 768,
      margin: 'auto',
      display: 'flex',
      flexDirection:'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    gridContainer: {
      height: 'auto',
    },
  }))
  
  export default function ViewSplitEstimate() {
    const { COMPANY_LOGO, COMPANY_NAME } = useCompanyProfile()
    const theme = useTheme()
    const { id } = useParams()
    const classes = useStyles()
    const edit = useLocation()?.state
    console.log('editttttttttttttt', edit)
    const xs = useMediaQuery(theme.breakpoints.down('xs'))
    const sm = useMediaQuery(theme.breakpoints.down('sm'))
    const mdd = useMediaQuery(theme.breakpoints.down('md'))
    const xld = useMediaQuery(theme.breakpoints.up('xl'))
    const componentRef = useRef()
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar()
    const user = JSON.parse(localStorage.getItem('user'))
    const [currentRFQData, setCurrentRFQdata] = useState({})
    console.log('currentRFQData', currentRFQData)
    const [openEdit, setOpenEdit] = useState(false)
    const [designs, setDesigns] = useState([])
    const [details, setDetails] = useState(null)
    console.log('details++++++++++++++++++', details)
    const [invoice, setInvoice] = useState(null)
    const [open, setIsOpen] = useState(false)
  
    const [addClient, setAddClient] = useState(false)
    const [addVendor, setAddVendor] = useState(false)
    const [progress, setProgress] = useState(null)
    const [openInvoice, setOpenInvoice] = useState(false)
    const [allClientsEdit, setAllClientsEdit] = useState(null)
    const [isCommunityLoading, setIsCommunityLoading] = useState(false)
    const [communities, setCommunities] = useState([])
    const [currentTab, setCurrentTab] = useState(
      user.isVendor ? 'Details' : 'Order Details',
    )
    const [openPreview, setOpenPreview] = useState(false)
    const [openConvertToSalesOrder, setOpenConvertToSalesOrder] = useState(false)
    const [openConvertToEstimate, setOpenConvertToEstimate] = useState(false)
    const [isConvertToSalesOrder, setIsConvertToSalesOrder] = useState(false)
    const [avatarUrl, setAvatarUrl] = useState([])
    const [initialAvatarUrls, setInitialAvatarUrls] = useState([]);
    const [allAvatarUrl, setAllAvatarUrl] = useState([])
    const [openDelete, setOpenDelete] = useState(false)
    const [reOpen, setReopen] = useState(false)
    const [confirmInvoice, setConfirmInvoice] = useState(false)
    const [convertToRFQ, setConvertToRFQ] = useState(false)
    const [invoiceReject, setRejectInvoice] = useState(false)
    // const [reqAcceptClient,setReqAcceptClient] = useState(false)
    const [reason, setReason] = useState('')
    const [acceptedClients, setAcceptedClients] = useState(null)
    const [updates, setUpdates] = useState(null)
    const [isSaving, setIsSaving] = useState(false)
    const [previewData, setPreviewData] = useState({})
    const [refresh, setRefresh] = useState(false)
    const ref = useRef()
    const [proposalData, setProposalData] = useState(null)
    const [teamMembers, setTeamMember] = useState([])
    const [customerData, setCustomerData] = useState([])
    const [jobNoteMembers, setJobNoteMembers] = useState(null)
    const [isMember, setIsMember] = useState(false)
    const [renderCards, setRenderCards] = useState(false)
    const [loading, setLoading] = useState(false)
    const printableContentRef = useRef()
    const [openHoldPopup, setOpenHoldPopup] = useState(false);
    const [holdReason, setHoldReason] = useState('');
    const [isSubmittingHold, setIsSubmittingHold] = useState(false);
    const [holdReasonError, setHoldReasonError] = useState('');
  
    const [isClientEdited, setIsClientEdited] = useState(false);
    const [showApprovalPopup, setShowApprovalPopup] = useState(false);
    const [recipes, setRecipes] = useState([])
    console.log('recipess', recipes)
    const [selectedRecipes, setSelectedRecipes] = useState([])
    console.log('selectedRecipes----', selectedRecipes)
    const [indexCounter, setIndexCounter] = useState(0);
    const [splitPercentage, setSplitPercentage] = useState(0);
  const [otherInstallationSplitManagementSettings, setOtherInstallationSplitManagementSettings] = useState([]);
  const [splitServices, setSplitServices] = useState([]);

  const stripRecipeTimestamp = (name = '') => name.replace(/-\d{14}$/, '');
  const sanitizeRecipe = (recipe = {}) => ({
    ...recipe,
    name: stripRecipeTimestamp(recipe?.name || recipe?.recipe_name || '')
  });
  const sanitizeRecipes = (list = []) => list.map((r) => sanitizeRecipe(r));

    // Memoized calculations for costs
    const productCost = useMemo(() => {
      if (!selectedRecipes || selectedRecipes.length === 0) return 0;
      
      const safeSplitPercentage = splitPercentage || 0;
      return selectedRecipes.reduce((total, data) => {
        const expectedCost = data?.expected_cost || 0;
        const splitAmount = expectedCost * (safeSplitPercentage / 100);
        const productCost = parseFloat((expectedCost + splitAmount).toFixed(2));
        return total + productCost;
      }, 0);
    }, [selectedRecipes, splitPercentage]);

    const installCost = useMemo(() => {
      if (!selectedRecipes || selectedRecipes.length === 0) return 0;
      
      return selectedRecipes.reduce((total, data) => {
        const installCost = data?.expected_install_labor_cost || 0;
        return total + installCost;
      }, 0);
    }, [selectedRecipes]);

    const serviceCost = useMemo(() => {
      if (!splitServices || splitServices.length === 0) return 0;
      
      return splitServices.reduce((total, service) => {
        return total + (service.total || 0);
      }, 0);
    }, [splitServices]);

    const totalCost = useMemo(() => {
      return productCost + installCost + serviceCost;
    }, [productCost, installCost, serviceCost]);

    // Direct selectedRecipes management functions
    const addNewProductRow = () => {
      const newIndexCounter = indexCounter + 1;
      setIndexCounter(newIndexCounter);
      
      const newRecipe = {
        id: newIndexCounter, // Use indexCounter as temporary ID
        product_name: '',
        name: null,
        recipe_name: null,
        recipe_id: null,
        expected_cost: 0,
        total_cost: 0,
        split_percentage: splitPercentage,
        split_estimate_id:id
      };
      
      setSelectedRecipes((prevRecipes) => [...prevRecipes, sanitizeRecipe(newRecipe)]);
    };

    const handleDeleteProduct = (recipeId) => {
      if (selectedRecipes.length > 1) {
        setSelectedRecipes((prevRecipes) => prevRecipes.filter(recipe => recipe.id !== recipeId));
      }
    };

    const handleProductNameChange = (recipeId, value) => {
      setSelectedRecipes((prevRecipes) => 
        prevRecipes.map(recipe => 
          recipe.id === recipeId ? { ...recipe, product_name: value } : recipe
        )
      );
    };

    // Initialize indexCounter when selectedRecipes is loaded
    useEffect(() => {
      if (selectedRecipes && selectedRecipes.length > 0) {
        setIndexCounter(Math.max(...selectedRecipes.map(r => r.id || 0)));
      }
    }, [selectedRecipes?.length]);

    // Initialize default recipe when isFromDesignOrder and selectedRecipes is empty
    useEffect(() => {
      if (openEdit && details?.isFromDesignOrder && selectedRecipes?.length === 0) {
        const newRecipe = {
          id: 0,
          product_name: '',
          name: null,
          recipe_name: null,
          recipe_id: null,
          expected_cost: 0,
          total_cost: 0,
          split_percentage: splitPercentage,
          split_estimate_id: id
        };
        setSelectedRecipes([newRecipe]);
        setIndexCounter(0);
      }
    }, [openEdit, details?.isFromDesignOrder, splitPercentage, id]);

  
    localStorage.setItem('requestId', id ? id : null)
    let userType = user.user_type
    let userId = user.user_id
    let isClient = user.isClient
  
    if (user.added_by_client && user.parent_user_type && user.parent_id) {
      userId = user.parent_id
      userType =3 // user.parent_user_type
    }
    const explodedPermissions = user?.exploded_permissions
    const [data, setData] = useState({})
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [formValues, setFormValues] = useState({})
    const [formDatas, setFormDatas] = useState({})
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isSubmittingReject, setIsSubmittingReject] = useState(false);
    const [additionalSelectedServices, setAdditionalSelectedServices] = useState(
      [],
    )
    const [initialSelectedServices, setInitialSelectedServices] = useState([])
    const [filteredServices, setFilteredServices] = useState([])
    const [membersLoading, setMembersLoading] = useState(false)
    const [filteredMembers, setFilteredMembers] = useState([])
    const [designers, setDesigners] = useState([])
    const [isUploading, setIsUploading] = useState(false)
  const [selectedPDF, setSelectedPDF] = useState(null)
  const [selectedPDFItem, setSelectedPDFItem] = useState(null)
  const [openPDFModal, setOpenPDFModal] = useState(false)
  const [pdfLoading, setPdfLoading] = useState(true)
    const [openDesignSelect, setOpenDesignSelect] = useState(false)
    const [selectedDesigns, setSelectedDesigns] = useState([])
  const [openImageModal,setOpenImageModal] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [openRecipeModal, setOpenRecipeModal] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [formulaName, setFormulaName] = useState(null);
  const [openCatalogModal, setOpenCatalogModal] = useState(false);
  const [selectedCatalogProductId, setSelectedCatalogProductId] = useState(null);
  const [catalogProductName, setCatalogProductName] = useState(null);
  const [catalogRecipeId, setCatalogRecipeId] = useState(null);
  const [selectedDesignsForEmail, setSelectedDesignsForEmail] = useState([]);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [emailModalDesigns, setEmailModalDesigns] = useState([]);
  
    const accessPublicMessageBoard = explodedPermissions?.some((permission) =>
      ['Access Design Order Client Message Board'].includes(permission),
    )
  
    const accessForApproveEstimateForClient = explodedPermissions?.some((permission) =>
      ['Approve Estimate For Client'].includes(permission),
    )
    const handleImageClick = (index) => {
      setCurrentImageIndex(index);
      setOpenImageModal(true);
    };
  
    const handlePrevious = () => {
      setCurrentImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
    };
  
    const handleNext = () => {
      setCurrentImageIndex((prevIndex) => (prevIndex < imageDesigns.length - 1 ? prevIndex + 1 : prevIndex));
    };
  
    const handleSendClientApproveReq = async (selectedDesigns) => {
      try {
        console.log('datailssssssssssss', details)
        const response = await axios.post(
          `${REST_API_END_POINT}design-order/sent-approve-req`,
          { design_order_id: details.id, client: details?.client, selectedDesigns: selectedDesigns },
        )
        if (response.data.status === 1) {
          enqueueSnackbar('Designs sent for client approval', { variant: 'success' })
        } else {
          enqueueSnackbar('Failed to send designs for client approval', { variant: 'error' })
        }
      } catch (error) {
        console.log('Error while sending client approval request:', error)
        enqueueSnackbar('Failed to send designs', { variant: 'error' })
      } finally {
        setRefresh(true);
        setOpenDesignSelect(false);
      }
    }

  const handleSendSelectedDesignsToEmail = () => {
    if (selectedDesignsForEmail.length === 0) {
      enqueueSnackbar('Please select at least one design', { variant: 'warning' })
      return
    }
    const selectedDesignFiles = designs?.filter((item) => selectedDesignsForEmail.includes(item.id))
    setEmailModalDesigns(selectedDesignFiles)
    setOpenEmailModal(true)
  }

  const handleSendCurrentItemToEmail = (item) => {
    if (!item || !item.id) {
      enqueueSnackbar('No item to send', { variant: 'warning' })
      return
    }
    setEmailModalDesigns([item])
    setOpenEmailModal(true)
  }

  const handleEmailSent = () => {
    setSelectedDesignsForEmail([])
  }
  
    const fetchDetails = async () => {
      try {
        const res = await axios.post(
          `${REST_API_END_POINT}settings/get-companyProfile-details`,
        )
        if (res.data.status === 1) {
          setData(...res.data.data)
        }
      } catch (error) {
        console.log('get-companyProfile-details error : ', error)
      }
    }
  
    const fetchAllRecipes = async () => {
      try {
        const res = await axios.post(REST_API_END_POINT + 'product/get-all-recipes')
        setRecipes(res.data.recipes)
      } catch (error) {
        console.log('get-all-recipes error : ', error)
      }
    }
    useEffect(() => {
      fetchDetails()
      fetchAllRecipes()
    }, [])

    // Calculate total_cost for all selectedRecipes when splitPercentage changes
    useEffect(() => {
      if (selectedRecipes.length > 0) {
        const safeSplitPercentage = splitPercentage || 0;
        const updatedRecipes = selectedRecipes.map(recipe => {
          const expectedCost = recipe?.expected_cost || 0;
          let expectedCostWithoutInstallLaborCost = expectedCost;
          const splitAmount = expectedCostWithoutInstallLaborCost * (safeSplitPercentage / 100);
          const totalCost = parseFloat((expectedCost + splitAmount + (recipe?.expected_install_labor_cost || 0)).toFixed(2));
          return {
            ...recipe,
            total_cost: totalCost ,
            split_percentage: safeSplitPercentage
          };
        });
        
        setSelectedRecipes(updatedRecipes);
        setFieldValue('recipes', updatedRecipes);
      }
    }, [splitPercentage])
  
    const handleChangeTab = (event, newValue) => {
      setCurrentTab(newValue)
      setRefresh(true)
    }
    const HandleClickmenu = () => {
      setAddClient(true)
    }
  
    const NewUserSchema = Yup.object().shape({
      name: Yup.string().required('Name is required'),
      description: Yup.string().required('Description is required'),
      
    })
    const LabelStyle = styled(Typography)(({ theme }) => ({
      ...theme.typography.subtitle2,
      // color: theme.palette.text.secondary,
      //   marginBottom: theme.spacing(1)
    }))
    const LabelStyleHead = styled(Typography)(({ theme }) => ({
      ...theme.typography.h5,
      // color: theme.palette.text.secondary,
    }))
    //delete design order
    const handleDeleteOrder = async () => {
      try {
        const targetFacilityId = details?.to_facility_id == currentFacilityId ? details?.origin_facility_id : details?.to_facility_id
        const data = { split_estimate_id: id, targetFacilityId, currentFacilityId }
        const res = await axios.post(
          `${REST_API}webservice/request/delete-split-estimate`,
          data,
        )
        if (res.data.status == 1) {
          enqueueSnackbar('Order deleted successfully', { variant: 'success' })
          navigate(PATH_DASHBOARD.quotation.splitEstimate)
        }
      } catch (error) {
        console.log(error, 'Error in deleting the order')
      }
    }
    //fetch request details
    const fetchRequestDetails = async () => {
      try {
        setLoading(true)
        const res = await axios.post(
          `${REST_API_END_POINT}request/fetch-all-split-estimate-details-by-id`,
          {
             id,
            userId,
            userType,
          },
        )

        const normalizedSplitEstimateAttachments = (res.data.splitEstimateAttachments || []).map((file) => {
          const resolvedUrl = file?.url || file?.name || '';
          const lowerUrl = String(resolvedUrl).toLowerCase();
          const normalizedExtension = (file?.extension || '').toLowerCase();
          const inferredExtension = normalizedExtension || (lowerUrl.includes('.pdf') ? 'pdf' : '');
          const normalizedFileType =
            (file?.file_type || '').toLowerCase().includes('pdf') || inferredExtension === 'pdf'
              ? 'application/pdf'
              : file?.file_type;

          return {
            ...file,
            url: resolvedUrl,
            name: file?.name || resolvedUrl,
            extension: inferredExtension,
            file_type: normalizedFileType,
          };
        });

          setAvatarUrl(normalizedSplitEstimateAttachments)
        const estimate = res?.data?.splitEstimate
        setDetails(res?.data?.splitEstimate);
        setInvoice(res?.data?.splitEstimate)
        setDesigns(normalizedSplitEstimateAttachments)
        
        setSelectedRecipes(sanitizeRecipes(res.data.splitEstimateRecipes || []))
        
        // Set split services if available
        if(res.data.splitEstimateServices && res.data.splitEstimateServices.length > 0) {
          setSplitServices(res.data.splitEstimateServices)
        }
        
        // Store otherInstallationSplitManagementSettings in state
        setOtherInstallationSplitManagementSettings(res?.data?.otherInstallationSplitManagementSettings || [])
        
        if(estimate?.origin_facility_id == currentFacilityId){
        let otherInstallationSplitManagementSettings = res?.data?.otherInstallationSplitManagementSettings
        let splitPercentage = otherInstallationSplitManagementSettings?.filter(setting => setting?.id == estimate?.to_facility_id)
        console.log('splitPercentage----', splitPercentage)
        setSplitPercentage(splitPercentage[0]?.split_percentage)
        }else{
          const currentFacilitySplitManagementSettings = res?.data?.currentFacilitySplitManagementSettings
          const currentSplitPercentage = currentFacilitySplitManagementSettings?.filter(setting => setting?.id == currentFacilityId)
          console.log('currentSplitPercentage', currentSplitPercentage)
          setSplitPercentage(currentSplitPercentage[0]?.split_percentage || 0)
        }
        
        setUpdates(res.data.updates)
        setRefresh(false)
        if (edit) {
          setOpenEdit(true)
        }
      } catch (error) {
        console.error('Error fetching design order details:', error)
      } finally {
        setLoading(false)
      }
    }
  
    useEffect(() => {
      if (openDesignSelect && designs?.length > 0) {
        const approvedDesignIds = designs
          .filter((d) => d.approved === 1)
          .map((d) => d.id);
  
        // Merge with existing selectedDesigns and remove duplicates
        setSelectedDesigns((prev) => {
          const merged = [...new Set([...prev, ...approvedDesignIds])];
          return merged;
        });
      }
    }, [openDesignSelect, designs]);
  
  

    useEffect(() => {
      const fetchAll = async () => {
        await Promise.all([
          fetchRequestDetails(),
        ])
      }
  
      fetchAll()
    }, [id, refresh])
  
    const handleSendEmail = async () => {
      try {
        let orderId = details?.id
        const res = await axios.post(`${REST_API}webservice/settings/send-mail`, {
          id: orderId,
        })
  
        if (res.data.status === 1) {
          enqueueSnackbar('Email send successfully', { variant: 'success' })
          setOpenInvoice(false)
        }
        return res.data
      } catch (error) {
        console.error('Error fetching request details:', error)
        throw error
      }
    }
    const addingInitialdataRFQ = async () => {
      // setLoading(true)
      try {
        if (openEdit) {
          let rfqCustomerData = allClientsEdit?.find(
            (cat) => cat?.id === customerData?.id,
          )
          let rfqCommunity = communities?.find(
            (com) => details?.community === com?.id,
          )
          setCurrentRFQdata({
            name: details?.name,
            description: details?.description,
            notes: details?.notes,
            client: rfqCustomerData,
            start: details?.start_date,
            community: rfqCommunity,
            end: details?.due_date,
            welcome_message: details?.welcome_message == 1 ? true : false || null,
            draft: details?.status == 4 ? true : false || null,
            order_id: invoice?.id,
            subject: details?.subject || null,
            email_content: details?.email_content || null,
            facility_type :FacilityTypes?.find(type => type.id === details?.to_facility_id) || null,
            recipes: selectedRecipes || null,
            to_facility_id: details?.to_facility_id || null,
            origin_facility_id: details?.origin_facility_id || null,
          })
  
          // Map the services data
          let result = initialSelectedServices
            .map((val) => {
              // Find the matching service in filteredServices
              let matchedService = filteredServices.find(
                (service) => service.id === val.labour_cost_service_id,
              )
  
              if (matchedService) {
                // Create a new object with updated quantity and total
                return {
                  ...matchedService,
                  quantity: val.quantity,
                  total: val.total,
                }
              }
              return null // Return null for unmatched services (optional)
            })
            .filter((item) => item !== null) // Remove any null entries
  
          // Set the matched and updated services to additionalSelectedServices
          setAdditionalSelectedServices(result)
        }
      } catch (error) {
        console.error('Error adding initial data for Sales Order:', error)
      } finally {
        // setTimeout(() => {
        //   setLoading(false)
        // }, 3000);
      }
    }
   

  
    useEffect(() => {
      // setLoading(true)
      addingInitialdataRFQ()
      setTimeout(() => {
        // setLoading(false)
      }, 3000)
    }, [openEdit, recipes])
    // }, [openEdit])
  
    const invoiceDate = moment.unix(details?.timestamp).format('MM/DD/YYYY')
  
    //edit rfq
    const handleEditClick = () => {
      setOpenEdit(!openEdit)
    }
    const handleDeleteMenu = () => {
      setOpenDelete(!openDelete)
    }
    const handleReopen = () => {
      setReopen(!reOpen)
    }
  
    const roundToThreeDecimals = (num) => Math.round(num * 1000) / 1000
  
    const calculateServiceTotal = (price, quantity, discount, location = 1) => {
      const parsedQuantity = parseFloat(quantity) || 1
      const parsedDiscount = parseFloat(discount) || 0
      const locationQuantity = parseFloat(location) || 1
      const subtotal = price * parsedQuantity * locationQuantity
      if (discount) {
        const totalDiscount = subtotal - discount
        return totalDiscount
      } else {
        return subtotal
      }
    }
  
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {
        name: currentRFQData.name || '',
        description: currentRFQData.description || '',
        facility_type: currentRFQData?.facility_type || null,
        recipes: currentRFQData?.recipes || [],
        split_services: [], // Don't include splitServices here to prevent reinitialization
        to_facility_id: currentRFQData?.to_facility_id || null,
        origin_facility_id: currentRFQData?.origin_facility_id || null,
      },
      validationSchema: NewUserSchema,
      onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
        try {
          // Validate that facility_type is selected
          if (!values.facility_type || values.facility_type === null || values.facility_type === undefined) {
            enqueueSnackbar('Please select a facility ', { variant: 'error' });
            setSubmitting(false);
            setErrors({ facility_type: 'Facility is required' });
            return;
          }
 
          setIsSubmitted(true)
          const split_estimate_id = Number(id)
          let allDesigns = [...avatarUrl, ...allAvatarUrl]
          values.avatarUrl = allDesigns?.map((file) => ({
            id: file.id || null,
            extension: file.extension,
            file_type: file.file_type,
            size: file.file_size || file.size,
            url: file.name || file.url,
  
            added_by: file.added_by || null,
            approved: file.approved || null,
            approved_by: file.approved_by || null,
            status: file.status || 1,
            isChat: file.isChat || 0,
            isDesign: file.isDesign ? file.isDesign : userType === 11 ? 1 : 2 ,
            isNew: file.isNew ? file.isNew : userType === 11 ? 1 : 2 ,
            reason: file.reason || null,
          }))
          // Keep split services inside values so deletions reflect in request
          values.split_services = splitServices || []
          
          // Validate that if isFromDesignOrder, at least one recipe with product_name is required
          if (details?.isFromDesignOrder && (selectedRecipes.length === 0 || selectedRecipes.every(recipe => !recipe.product_name || recipe.product_name.trim() === ''))) {
            enqueueSnackbar('Please add at least one product name before saving', { variant: 'error' });
            setIsSubmitted(false);
            return;
          }
          
          let targetFacilityId = values.to_facility_id == currentFacilityId ? values.origin_facility_id : values.to_facility_id
          
          const safeSplitPercentage = splitPercentage || 0;
          const updatedRecipes = selectedRecipes.map(recipe => {
          const expectedCost = recipe?.expected_cost || 0;
          let expectedCostWithoutInstallLaborCost = expectedCost;
          const splitAmount = expectedCostWithoutInstallLaborCost * (safeSplitPercentage / 100);
          const totalCost = parseFloat((expectedCost + splitAmount + (recipe?.expected_install_labor_cost || 0)).toFixed(2));
          return {
            ...recipe,
            total_cost: totalCost ,
            split_percentage: safeSplitPercentage
          };
        });
          // values.selectedRecipes = updatedRecipes
  
          const data = {
            values,
            userId,
            userType,
            split_estimate_id,
            selectedRecipes : updatedRecipes,
            currentFacilityId,
            targetFacilityId,
            totalCost: totalCost,
            serviceCost: serviceCost
          }
          setFormValues(values)
          setFormDatas(data)
          handleConfirmSubmit(values, data)
        } catch (error) {
          console.error(error)
        }
      },
    })
  console.log('formik.values', formik.values)
    const handleConfirmSubmit = async (values = null, data = null) => {
      setIsSubmitting(true)
      try {
        const formValuesData = values || formValues
        const formDatasData = data || formDatas
        console.log('Form Values:', formValuesData)
        console.log('Form Data:', formDatasData)
        await axios
          .post(`${REST_API}webservice/request/update-split-estimate`, formDatasData)
          .then((res) => {
            setOpenEdit(false)
            setIsOpen(false)
            setCurrentRFQdata({})
            fetchRequestDetails()
            if (edit) {
              navigate(PATH_DASHBOARD.quotation.splitEstimate)
            }
            enqueueSnackbar('Update success', { variant: 'success' })
            formik.resetForm()
            setDesigners([])
            setAdditionalSelectedServices([])
            // resetForm();
          })
          .catch((errors) => {
            console.log(errors, 'error')
          })
      } catch (error) {
        console.error('Error submitting form:', error)
        enqueueSnackbar('An error occurred during submission.', {
          variant: 'error',
        })
      } finally {
        setIsSubmitting(false)
        setFormValues({})
        setFormDatas({})
        setDesigners([])
      }
    }
  
    const current = moment()
  
    const handleAcceptorRejectInvoice = async (value) => {
      try {
        if (value === 3 && reason === '') {
          enqueueSnackbar('Please fill rejected reason ', { variant: 'warning' })
          return
        } else {
    let targetFacilityId = details?.to_facility_id == currentFacilityId ? details?.origin_facility_id : details?.to_facility_id
          let newStatus = value == 1 ? 2 : 6
          const data = {
            split_estimate_id : id,
            status: value,
            userId,
            reason: reason || '',
            targetFacilityId,
            currentFacilityId,
          }
          const res = await axios.post(
            `${REST_API}webservice/request/update-split-estimate-status`,
            data,
          )
  
          if (res.data.status == 1) {
            setOpenInvoice(false)
            setConfirmInvoice(false)
            setRejectInvoice(false)
            enqueueSnackbar('Order Approved', { variant: 'success' })
            fetchRequestDetails()
          } else if (res.data.status == 2) {
            setOpenInvoice(!openInvoice)
            setConfirmInvoice(false)
            setRejectInvoice(false)
            enqueueSnackbar('Order Rejected', { variant: 'error' })
            setReason('')
            navigate(PATH_DASHBOARD.design.root)
          } else {
            setOpenInvoice(!openInvoice)
            setConfirmInvoice(false)
            setRejectInvoice(false)
            enqueueSnackbar(res.data.message, { variant: 'error' })
          }
        }
      } catch (error) {
        console.log(error, 'error in accepting invoice')
        setConfirmInvoice(false)
        setRejectInvoice(false)
        enqueueSnackbar('Server Error', { variant: 'error' })
      }
    }

    const handleConvertToEstimate = async (existingJob = false) => {
      try {
        let targetFacilityId = details?.to_facility_id == currentFacilityId ? details?.origin_facility_id : details?.to_facility_id
        const data = {
          split_estimate_id : id,
          userId,
          targetFacilityId,
          currentFacilityId,
          isSalesOrder: isConvertToSalesOrder || false,
        }
        const res = await axios.post(
          `${REST_API}webservice/request/convert-split-estimate-to-estimate`,
          data,
        )
        if (res.data.status == 1) {
          const id = res.data?.request_id
          setOpenConvertToEstimate(false)
          if(res.data?.isSalesOrder){
            enqueueSnackbar('Split Estimate converted to Sales Order successfully', { variant: 'success' })
            navigate(`/dashboard/split-order/split-sales-order/view/${id}`, { state: { fromSplitEstimate: true } })
          }else{
            enqueueSnackbar('Split Estimate converted to Estimate successfully', { variant: 'success' })
            navigate(`/dashboard/quick-bid/view/${id}`, { state: true })
          }
          // enqueueSnackbar('Split Estimate converted to Estimate successfully', { variant: 'success' })
          // navigate(`/dashboard/quick-bid/view/${id}`, { state: true })
        } else {
          setOpenConvertToEstimate(false)
          setIsConvertToSalesOrder(false)
          enqueueSnackbar('Failed to convert Split Estimate to Estimate', { variant: 'error' })
        }
      } catch (error) {
        console.log(error, 'error in converting Split Estimate to Estimate')
        setOpenConvertToEstimate(false)
        enqueueSnackbar('Server Error', { variant: 'error' })
      } finally {
      }
    }
  
    const handleConvertToSalesOrder = async (existingJob = false) => {
      try {
        setOpenConvertToSalesOrder(false)
        setConvertToRFQ(true)
        let design_order_id = id
        let userName = user.first_name
  
        const data = {
          design_order_id,
          userId,
          userType,
          userName,
          salesOrder: true,
          isDesignOrder: true,
        }
        const res = await axios.post(
          `${REST_API}webservice/design/convert-design-to-sales-order`,
          data,
        )
  
        if (res.data.request_id) {
          const id = res.data.request_id
          setConfirmInvoice(false)
          setRejectInvoice(false)
          enqueueSnackbar('Order converted to Sales Order successfully', {
            variant: 'success',
          })
          sessionStorage.setItem(`salesOrderSkipRibbonDismiss_${id}`, '1')
          navigate(`/dashboard/official-request/view/${id}`, { state: true })
        } else {
          setConfirmInvoice(false)
          setRejectInvoice(false)
          enqueueSnackbar('Failed to convert Design to Sales Order', {
            variant: 'error',
          })
        }
      } catch (error) {
        console.log(error, 'error in Converting Design to Sales Order')
        setConfirmInvoice(false)
        setRejectInvoice(false)
        enqueueSnackbar('Server Error', { variant: 'error' })
      } finally {
        setConvertToRFQ(false)
      }
    }
  
    // const handleConvertToEstimate = async (existingJob = false) => {
    //   try {
    //     setOpenConvertToEstimate(false)
    //     setConvertToRFQ(true)
    //     let design_order_id = id
    //     let userName = user.first_name
  
    //     const data = {
    //       design_order_id,
    //       userId,
    //       userType,
    //       userName,
    //       salesOrder: null,
    //       isDesignOrder: true,
    //     }
    //     const res = await axios.post(
    //       `${REST_API}webservice/design/convert-design-to-sales-order`,
    //       data,
    //     )
  
    //     if (res.data.request_id) {
    //       const id = res.data.request_id
    //       setConfirmInvoice(false)
    //       setRejectInvoice(false)
    //       enqueueSnackbar('Order converted to Estimate successfully', {
    //         variant: 'success',
    //       })
    //       navigate(`/dashboard/quick-bid/view/${id}`, { state: true })
    //     } else {
    //       setConfirmInvoice(false)
    //       setRejectInvoice(false)
    //       enqueueSnackbar('Failed to convert Design to Estimate', {
    //         variant: 'error',
    //       })
    //     }
    //   } catch (error) {
    //     console.log(error, 'error in Converting Design to Estimate')
    //     setConfirmInvoice(false)
    //     setRejectInvoice(false)
    //     enqueueSnackbar('Server Error', { variant: 'error' })
    //   } finally {
    //     setConvertToRFQ(false)
    //   }
    // }
  
    const handleReopeningRequest = async () => {
      try {
        let requestId = id
  
        const data = { requestId, userId }
        const res = await axios.post(`${REST_API}webservice/request/reopen`, data)
        if (res.data.status == 1) {
          enqueueSnackbar('Request reopened successfully', { variant: 'success' })
          setReopen(false)
          fetchRequestDetails()
        } else if (res.data.status == 0) {
          enqueueSnackbar('Request reopened failed', { variant: 'error' })
          setReopen(false)
        }
      } catch (error) {
        console.log(error, 'Error in reopen')
      }
    }
  
    const {
      errors,
      values,
      touched,
      handleSubmit,
      setFieldValue,
      getFieldProps,
    } = formik

    // Update formik field whenever selectedRecipes changes
    useEffect(() => {
      setFieldValue('recipes', selectedRecipes);
    }, [selectedRecipes, setFieldValue]);

    // Update formik field whenever splitServices changes
    useEffect(() => {
      setFieldValue('split_services', splitServices)
    }, [splitServices, setFieldValue])
  
    const setValuesToPreview = () => {
      setPreviewData(values)
    }
  
    const handleRemoveAll = () => {
      setAvatarUrl([])
    }
  
    const handleRemove = (file) => {
      console.log('filefilefilefilefilefilefile', file)
      const filteredItems = avatarUrl.filter((_file) => _file !== file)
      if (filteredItems) {
        setAvatarUrl(filteredItems)
      } else {
        setAvatarUrl([])
      }
      // const filteredAllItems = allAvatarUrl.filter((item) => item.id !== file.id)
      // if(filteredAllItems) {
      //   setAllAvatarUrl(filteredAllItems)
      // }
    }
  

  
    const handleDrop = useCallback(
      async (acceptedFiles) => {
        if (!acceptedFiles || acceptedFiles.length === 0) return;
  
        setIsUploading(true);
  
        try {
          const uploadPromises = acceptedFiles.map(async (file) => {
            const timestamp = Date.now();
            const sanitizedName = file.name.replace(/\s+/g, '_');
            const fileName = `${timestamp}_${sanitizedName}`;
            const filePath = `design-order/designs/${fileName}`;   // 🔑 folder path
  
            // ---------- 1. Upload ----------
            const { error: uploadError } = await supabase.storage
              .from('signwise-attachments')                           // your bucket
              .upload(filePath, file);
  
            if (uploadError) throw uploadError;
  
            // Optionally flag progress done for this file
            setProgress(100);
  
            // ---------- 2. Public URL ----------
            const { data: publicUrlData, error: urlError } = supabase.storage
              .from('signwise-attachments')
              .getPublicUrl(filePath);
  
            if (urlError || !publicUrlData?.publicUrl) {
              throw new Error('Failed to generate public URL');
            }
  
            // ---------- 3. Return metadata ----------
            return {
              url: publicUrlData.publicUrl,
              file_type: file.type,
              extension: file.name.split('.').pop(),
              size: file.size,
            };
          });
  
          const uploadedFiles = await Promise.all(uploadPromises);
  
          setAvatarUrl((prev) => [...prev, ...uploadedFiles]);
        } catch (err) {
          console.error('Upload error:', err.message);
          enqueueSnackbar('Upload failed: ' + err.message, { variant: 'error' });
        } finally {
          setIsUploading(false);
          setProgress(null);   // clear progress bar
        }
      },
      [setAvatarUrl, setIsUploading, setProgress]
    ); // supabase integration
  

  
    let subTotal = 0
    const ACCOUNT_TABS = [
      {
        value: `Order Details`,
        component: details ? (
          <ViewSplitEstimateDetails
            teamMembers={teamMembers}
            clientDetails={invoice}
            products={invoice?.cust_product}
            fetchRequestDetails={fetchRequestDetails}
            user={user}
            designs={designs}
            setDesigns={setDesigns}
            details={details}
            designStatus={details?.status}
            isRequest={true}
            requestId={id}
            invoice={invoice}
            isDesign={true}
            setRefresh={setRefresh}
            refresh={refresh}
            selectedRecipes={selectedRecipes}
            splitServices={splitServices}
          />
        ) : (
          ''
        ),
      },
      ...(user.isVendor ? [] : [
        {
          value: 'Job Log',
          component: <RequestTabUpdates updates={updates?.length > 0 ? updates : []} details={details}/>,
        },
      ]),
    ]
  
    const handleCancel = async () => {
      setOpenEdit(false)
      setIsOpen(false)
      setCurrentRFQdata({})
      fetchRequestDetails()
      setAvatarUrl([])
      setDesigners([])
      setAdditionalSelectedServices([])
  
      if (edit) {
        navigate(PATH_DASHBOARD.quotation.splitEstimate)
      }
    }
    const handleSubmitOrder = async () => {
      setOpenEdit(false)
      setIsOpen(false)
      setCurrentRFQdata({})
      fetchRequestDetails()
      setAvatarUrl([])
      setDesigners([])
      setAdditionalSelectedServices([])
      enqueueSnackbar('Split Estimate submitted successfully', { variant: 'success' })
  
      if (edit) {
        navigate(PATH_DASHBOARD.quotation.splitEstimate)
      }
    }
  
    let selectedServicesTotalCost = additionalSelectedServices?.reduce(
      (total, service, index) => {
        const serviceTotal = calculateServiceTotal(
          service?.total_cost,
          service?.quantity,
          0,
          1,
        )
  
        // return total + Number(service?.total);
        return total + Number(serviceTotal)
      },
      0,
    )
  
    // selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost);
    const handleChangeSort = (category) => {
      setSort(category)
      setSortOpen(false)
    }
  
    selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost)
    const selectedServicesSubTotal = selectedServicesTotalCost
  

  const  handleRemoveRecipe = (id) => {
    const filteredRecipes = selectedRecipes.filter(data => data.id !== id)
    setSelectedRecipes(filteredRecipes)
    setFieldValue('recipes', filteredRecipes)
  }

  const handleRemoveSplitService = (serviceId) => {
    const filtered = splitServices.filter((s) => s.id !== serviceId)
    setSplitServices(filtered)
  }

  const handleOpenRecipeModal = (productId,formulaName) => {
    setSelectedProductId(productId);
    setOpenRecipeModal(true);
    setFormulaName(formulaName);
  }

  const handleOpenCatalogModal = (productId, productName,recipeId) => {
    setSelectedCatalogProductId(productId);
    setOpenCatalogModal(true);
    setCatalogProductName(productName);
    setCatalogRecipeId(recipeId);
  };


    const handleRecipeCreated = (newRecipe) => {
    console.log('newRecipeeeeeeeee', newRecipe)
    // Add the new recipe to the recipes list
    // setRecipes(prevRecipes => [...prevRecipes, newRecipe]);
    
    // Calculate total_cost = expected_cost + (expected_cost * splitPercentage / 100)
    const expectedCost = newRecipe.expectedCost || 0;
    const cleanName = stripRecipeTimestamp(newRecipe.name || newRecipe.recipe_name || '');
    const splitAmount = expectedCost * (splitPercentage / 100);
    const totalCost = parseFloat((expectedCost + splitAmount).toFixed(2));
    
      // Update the specific row in selectedRecipes with the new recipe data
      const updatedSelectedRecipes = selectedRecipes.map(item => 
        item.id === selectedProductId 
          ? { 
              ...item, 
              name: cleanName,
              recipe_name: newRecipe.recipe_name, 
              recipe_id: newRecipe.id,
              expected_cost: newRecipe.expectedCost,
              total_cost: totalCost,
              split_percentage: splitPercentage,
              expected_install_labor_cost: newRecipe.expected_install_labor_cost || 0
            }
          : item
      );
    
    setSelectedRecipes(updatedSelectedRecipes);
    
    // Update the formik values as well
    setFieldValue('recipes', updatedSelectedRecipes);
    
    // Close the modal
    setOpenRecipeModal(false);
  }


  
    const fetchAllProjectMembers = async (services) => {
      setMembersLoading(true)
  
      const workflowIds = services
        .map((service) => service.workflow)
        .filter((id) => id !== null && id !== undefined)
  
      const uniqueWorkflowIds = [...new Set(workflowIds)]
  
      try {
        const res = await axios.post(
          `${REST_API}webservice/workflow/project-members`,
          {
            workflow: uniqueWorkflowIds,
          },
        )
  
        if (res.data?.projectManagers) {
          setDesigners(res.data.projectManagers)
        }
      } catch (error) {
        console.error('Error in fetching project members:', error)
        setDesigners([])
      } finally {
        setMembersLoading(false)
      }
    }
  
    const handleUpdateHoldStatus = async (reason) => {
      try {
        const res = await axios.post(
          `${REST_API_END_POINT}project/update-design-order-job-hold-status`,
          {
            projectId: details?.id,
            userId: user.user_id,
            reason: reason || '',
            designOrder: true,
          },
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );
        if (res.data.status === 1) {
          enqueueSnackbar(res.data.message, { variant: 'success' });
          fetchRequestDetails()
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' });
        }
      } catch (error) {
        console.error('Error updating hold status:', error);
      }
    };
  
    const filteredDesigns = designs
    const imageDesigns = filteredDesigns || []
    return (
      <Page title="View Request: View | Sign Wise Solutions">
        {loading || convertToRFQ ? (
          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              alignContent: 'center',
            }}
          >
            <LoadingScreen />
          </Stack>
        ) : (
          <Container>
            <Button
              variant="outlined"
              type="submit"
              // onClick={()=>navigate(PATH_DASHBOARD.official.root)}
              // onClick={() => { window.history.back() }}
              onClick={() => (openEdit ? handleCancel() : window.history.back())}
              sx={{ alignItems: 'flex-end', mb: 4 }}
              startIcon={
                // Use the startIcon prop to add an icon to the left
                <Stack>
                  <KeyboardBackspaceOutlined />
                </Stack>
              }
            >
              Back
            </Button>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <HeaderBreadcrumbs heading={details?.name} />
              {!openEdit && (
                <Stack marginBottom={5} flexDirection={'column'}>
                  <Stack
                    direction={'row'}
                    alignItems={'center'}
                    spacing={1}
                  ></Stack>
                  {(userType != 3 ) ? (
                    <Stack>
                        <Stack flexDirection={'row'} gap={2}>
                          {/* {details?.design_order_job_status === 3 || details?.status === 3 || details?.hold == 1 ? ( */}
                          {details?.origin_facility_id === currentFacilityId && 
                           selectedRecipes.length > 0 &&
                           selectedRecipes.every(recipe => recipe.product_added === 1) ? (
                            <AnimatedButton
                              title={'Create Client Estimate'}
                              onClick={() => {
                                setOpenConvertToEstimate(true)
                              }}
                            />
                          ):''}
                          {details?.origin_facility_id === currentFacilityId && 
                           selectedRecipes.length > 0 &&
                           selectedRecipes.every(recipe => recipe.product_added === 1) ? (
                            <AnimatedButton
                              title={'Create Client Sales Order'}
                              onClick={() => {
                                setOpenConvertToEstimate(true)
                                setIsConvertToSalesOrder(true)
                              }}
                            />
                          ):''}
                          {((details?.origin_facility_id === currentFacilityId && details?.status === 1) || 
                            (details?.to_facility_id === currentFacilityId && details?.status !== 5)) ? (
                          <Tooltip title="Edit">
                            <IconButton
                              sx={{ backgroundColor: theme.palette.divider }}
                              onClick={() => {
                                explodedPermissions?.some((permission) =>
                                  ['Edit Design Order'].includes(permission),
                                )
                                  ? handleEditClick()
                                  : enqueueSnackbar(
                                      'Access Denied: You do not have sufficient permissions',
                                      { variant: 'error' },
                                    )
                              }}
                            >
                              <Icon
                                icon={editFill}
                                width={24}
                                height={24}
                                color="#ffffff"
                              />
                            </IconButton>
                          </Tooltip>
                          ) : ''}
  
                       
                        {details?.status !== 1 ? (
                          ''
                        ) : (
                          <Tooltip title="Delete">
                            <IconButton
                              sx={{ backgroundColor: theme.palette.divider }}
                              onClick={() => {
                                explodedPermissions?.some((permission) =>
                                  ['Delete Design Order'].includes(permission),
                                )
                                  ? handleDeleteMenu()
                                  : enqueueSnackbar(
                                      'Access Denied: You do not have sufficient permissions',
                                      { variant: 'error' },
                                    )
                              }}
                            >
                              <Icon
                                icon={trash2Outline}
                                width={24}
                                height={24}
                                color="#ffffff"
                              />
                            </IconButton>
                          </Tooltip>
                        )}
                        {(explodedPermissions?.some((permission) =>
                          [
                            'Create Design Order',
                            'Edit Design Order',
                            'Delete Design Order',
                          ].includes(permission),
                        ) && !isClient && userType !==3)
                          ? details?.status === 2 &&
                            details?.hold == 0 && (
                              <AnimatedButton
                                title={'Convert to Estimate'}
                                onClick={() => {
                                  setOpenConvertToEstimate(true)
                                }}
                              />
                            )
                          : ''}
                        {(explodedPermissions?.some((permission) =>
                          [
                            'Create Design Order',
                            'Edit Design Order',
                            'Delete Design Order',
                          ].includes(permission),
                        )  && !isClient && userType !==3)
                          ? details?.status === 2 &&
                            details?.hold == 0 && (
                              <AnimatedButton
                                title={'Convert to Sales Order'}
                                onClick={() => {
                                  setOpenConvertToSalesOrder(true)
                                }}
                              />
                            )
                          : ''}
                      </Stack>
                    </Stack>
                  ) : details?.status === 3 ||
                    details?.status === 2 ||
                    details?.hold == 1 ? (
                    ''
                  ) : (
                    <>
                      {details?.origin_facility_id === currentFacilityId && 
                       selectedRecipes.length > 0 && 
                       selectedRecipes.every(recipe => recipe.product_added === 1) ? (
                        <AnimatedButton
                          title={'Create Client Estimate'}
                          onClick={() => {
                            setOpenConvertToEstimate(true)
                          }}
                        />
                      ):''}
                      <Tooltip title="Edit">
                        <IconButton
                          sx={{ backgroundColor: theme.palette.divider }}
                          onClick={() => {
                            explodedPermissions?.some((permission) =>
                              ['Edit Design Order'].includes(permission),
                            ) || (userType == 3)
                              ? handleEditClick()
                              : enqueueSnackbar(
                                  'Access Denied: You do not have sufficient permissions',
                                  { variant: 'error' },
                                )
                          }}
                        >
                          <Icon
                            icon={editFill}
                            width={24}
                            height={24}
                            color="#ffffff"
                          />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </Stack>
              )}
            </Stack>
            {openEdit && (
              <FormikProvider value={formik}>
                <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                      <Card sx={{ p: 3 }}>
                        <Stack spacing={3}>
                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                          >
                            <Stack flexDirection={'column'}>
                              {/* <LabelStyle>Name</LabelStyle> */}
                              <TextField
                                //   fullWidth
                                sx={{ width: 400 }}
                                label="Order Name"
                                {...getFieldProps('name')}
                                error={Boolean(touched.name && errors.name)}
                                helperText={touched.name && errors.name}
                              />
                            </Stack>
                          </Stack>
                          {/* <LabelStyle>Description</LabelStyle> */}
                          <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            maxRows={7}
                            label="keep the summary brief and make it communicates"
                            {...getFieldProps('description')}
                            error={Boolean(
                              touched.description && errors.description,
                            )}
                            helperText={touched.description && errors.description}
                          />
                                          {((details?.status ==1 && details?.origin_facility_id == currentFacilityId && details?.total_cost == 0) || 
                            (details?.isFromDesignOrder && selectedRecipes.length > 0 && values.origin_facility_id == currentFacilityId)) ? (
                            <>
                              <LabelStyle>Products</LabelStyle>
                              <TableContainer component={Paper} sx={{ mt: 2 }}>
                                <Table>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell align="center">Sl No</TableCell>
                                      <TableCell align="center">Product</TableCell>
                                      <TableCell align="center"></TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {selectedRecipes.map((recipe, index) => (
                                      <TableRow key={recipe.id}>
                                        <TableCell align="center">{index + 1}</TableCell>
                                        <TableCell align="center">
                                          <TextField
                                            fullWidth
                                            variant="outlined"
                                            value={recipe.product_name || ''}
                                            onChange={(e) => handleProductNameChange(recipe.id, e.target.value)}
                                            placeholder="Product Name"
                                          />
                                        </TableCell>
                                        <TableCell align="center">
                                            {selectedRecipes.length > 1 && (
                                              <IconButton 
                                                onClick={() => handleDeleteProduct(recipe.id)}
                                                color="error"
                                              >
                                                <Delete />
                                              </IconButton>
                                            )}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start'}}>
                                <Button
                                  variant="outlined"
                                  startIcon={<Icon icon={plusFill} />}
                                  onClick={addNewProductRow}
                                  sx={{
                                    marginLeft: '20px'
                                  }}
                                >
                                  Add Row
                                </Button>
                              </Box>
                              <Divider />
                            </>
                          ):''}
                     <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Autocomplete
                          sx={{ width: '50%' }}
                          id="combo-box-demo-type-single"
                          options={filteredOtherFacilityTypes || []}
                          value={values.facility_type}
                          disabled={details?.to_facility_id}
                          onChange={(event, newValue) => {
                            setFieldValue('facility_type', newValue);
                            setFieldValue('to_facility_id', newValue?.id || null);
                            
                            // Set split percentage when facility_type matches otherInstallation ID
                            if (newValue && otherInstallationSplitManagementSettings) {
                              const matchedSetting = otherInstallationSplitManagementSettings.find(
                                setting => setting?.id == newValue.id
                              );
                              
                              if (matchedSetting) {
                                const newSplitPercentage = matchedSetting.split_percentage || 0;
                                setSplitPercentage(newSplitPercentage);
                                
                                // Update all existing selectedRecipes with the new split percentage
                                setSelectedRecipes((prevRecipes) => 
                                  prevRecipes.map(recipe => ({
                                    ...recipe,
                                    split_percentage: newSplitPercentage
                                  }))
                                );
                              }
                            } else if (!newValue) {
                              // Reset to 0 when no facility is selected
                              setSplitPercentage(0);
                              
                              // Update all existing selectedRecipes to 0
                              setSelectedRecipes((prevRecipes) => 
                                prevRecipes.map(recipe => ({
                                  ...recipe,
                                  split_percentage: 0
                                }))
                              );
                            }
                          }}
                          getOptionLabel={(option) => option?.label ?? ''}
                          isOptionEqualToValue={(option, value) => option?.id === value?.id}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              label="Choose Facility"
                              placeholder="Select facility"
                              error={Boolean(touched.facility_type && errors.facility_type)}
                              helperText={touched.facility_type && errors.facility_type}
                            />
                          )}
                        />
                      </Stack>

                          <LabelStyle>Upload File</LabelStyle>
                      
                          <UploadMultiFile
                            showPreview
                            // maxSize={1024 * 1024 * 1024}
                            maxSize={1024 * 1024 * 1024}
                            accept="image/*,application/pdf"
                            files={avatarUrl}
                            onDrop={handleDrop}
                            onRemove={handleRemove}
                            onRemoveAll={handleRemoveAll}
                            isUploading={isUploading}
                          />
                          {
                            values.origin_facility_id == currentFacilityId && selectedRecipes.length == 0 ? "" :
                         <Typography variant="h6" align="left">Product Formulas</Typography>
                          }
{
  values.origin_facility_id == currentFacilityId ? "":(
    <>


                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <Autocomplete
                              sx={{ width: '50%' }}
                              multiple={true}
                              options={recipes}
                              disabled={true}
                              value={values.recipes}
                              onChange={(event, newValue) => {
                                // Calculate total_cost = expected_cost + (expected_cost * splitPercentage / 100) for selected recipes
                                const updatedRecipes = newValue.map(recipe => {
                                  const expectedCost = recipe?.expected_cost || 0;
                                  const splitAmount = expectedCost * (splitPercentage / 100);
                                  const totalCost = parseFloat((expectedCost + splitAmount).toFixed(2));
                                  return {
                                    ...recipe,
                                    total_cost: totalCost,
                                    split_percentage: splitPercentage,
                                    expected_install_labor_cost: recipe?.expected_install_labor_cost || 0
                                  };
                                });
                                
                                setFieldValue('recipes', updatedRecipes);
                                setSelectedRecipes(updatedRecipes);
                              }}
                              getOptionLabel={(option) => option.name}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Select Product Formulas"
                                />
                              )}
                              isOptionEqualToValue={(option, value) => option.id === value.recipe_id }
                              renderTags={(tagValue, getTagProps) =>
                                tagValue
                                  .filter((option) => option?.name && option.name.trim() !== '') // only render chips with name
                                  .map((option, index) => (
                                    <Chip
                                      {...getTagProps({ index })}
                                      key={option.id}
                                      label={option.name}
                                    />
                                  ))
                              }
                            />
                          </Stack>
                          </>   )
}
                         { selectedRecipes && selectedRecipes.length > 0 ? (
                          <TableContainer component={Paper} sx={{ mt: 2 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Product</TableCell>
                                  <TableCell align="center">Formula</TableCell>
                                  <TableCell align="center">Outgoing Percentage</TableCell>
                                  <TableCell align="center">Actual Cost</TableCell>
                                  <TableCell align="center">
                                    <Tooltip title="Actual Cost + Outgoing Percentage" arrow>
                                      <Typography variant="subtitle2">Split Retail Cost</Typography>
                                    </Tooltip>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Tooltip title="Product Cost + Install Cost" arrow>
                                      <Typography variant="subtitle2">Total Cost</Typography>
                                    </Tooltip>
                                  </TableCell>
                                  <TableCell align="center"></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedRecipes.map((data, index) => {
                                  data.name = data?.name || data?.recipe_name
                                  const displayName = stripRecipeTimestamp(data.name || '');
                                  data.recipe_id = data?.recipe_id    
                                  
                                  // Calculate total_cost = expected_cost + (expected_cost * splitPercentage / 100)
                                  const expectedCost = data?.expected_cost || 0;
                                  let expectedCostWithoutInstallLaborCost = expectedCost;
                                  const safeSplitPercentage = splitPercentage || 0;
                                  const splitAmount = expectedCostWithoutInstallLaborCost * (safeSplitPercentage / 100);
                                  const totalCost = parseFloat((expectedCost + splitAmount + (data?.expected_install_labor_cost || 0)).toFixed(2));
                                  let expectedCostWithInstallLaborCost = expectedCost + (data?.expected_install_labor_cost || 0);
                                  const lineTotalwithoutInstall = parseFloat((expectedCost + splitAmount).toFixed(2));
                                  return (
                                     <>
                                       <TableRow key={index}>
                                         <TableCell>{data?.product_name || '-'}</TableCell>
                                         <TableCell align="center">
                                           {data?.name ? (
                                             <Tooltip title={displayName} arrow>
                                               <Typography variant="body2" sx={{ 
                                                 maxWidth: 200, 
                                                 overflow: 'hidden', 
                                                 textOverflow: 'ellipsis',
                                                 whiteSpace: 'nowrap'
                                               }}>
                                                 {displayName.length > 30 ? `${displayName.substring(0, 30)}...` : displayName}
                                               </Typography>
                                             </Tooltip>
                                           ) : values.origin_facility_id == currentFacilityId ? "-" : (
                                                 <Button
                                                   variant="outlined"
                                                   startIcon={<Icon icon={plusFill} />}
                                                   onClick={() => handleOpenRecipeModal(data.id,data?.product_name)}
                                                   sx={{
                                                     marginLeft: '20px'
                                                   }}
                                                 >
                                                   Add Split Formula
                                                 </Button>
                                           )}
                                         </TableCell>
                                         <TableCell align="center">
                                           <Typography variant="body2">
                                             {(splitPercentage || 0)}%
                                           </Typography>
                                         </TableCell>
                                         <TableCell align="center">
                                           <Typography variant="body2">
                                             {(expectedCost).toFixed(2)}
                                           </Typography>
                                         </TableCell>
                                         <TableCell align="center">
                                         {/* {(data?.expected_install_labor_cost == null || data?.expected_install_labor_cost <= 0) ? */}
                                           <Tooltip title={`${expectedCost.toFixed(2)} + ${splitAmount.toFixed(2)} = ${lineTotalwithoutInstall.toFixed(2)}`} arrow>
                                             <Typography variant="body2">
                                               ${lineTotalwithoutInstall.toFixed(2)}
                                             </Typography>
                                           </Tooltip>
                                           {/* :'-'} */}
                                         </TableCell>
                                         <TableCell align="center">
                                           {data?.expected_install_labor_cost && data?.expected_install_labor_cost > 0 ? (
                                             <Typography variant="body2">
                                               -
                                             </Typography>
                                           ) : (
                                             <Typography variant="body2">
                                               ${totalCost.toFixed(2)}
                                             </Typography>
                                           )}
                                         </TableCell>
                                         
                                         <TableCell>
                                           {
                                             (details?.status == 2 || details?.status == 5)? 
                                               <Button
                                                 variant="outlined"
                                                 startIcon={<Icon icon={data?.product_added === 1 ? checkmarkFill : plusFill} />}
                                                 onClick={() => handleOpenCatalogModal(data.id, data?.product_name,data?.recipe_id)}
                                                 disabled={data?.product_added === 1 || values.origin_facility_id == currentFacilityId  }
                                                 sx={{
                                                   marginLeft: '20px'
                                                 }}
                                               >
                                                 {data?.product_added === 1 ? 'Catalog Added' : 'Add Split Catalog'}
                                               </Button>
                                             :
                                             values.origin_facility_id == currentFacilityId ? "" :
                                             <IconButton onClick={() => handleRemoveRecipe(data.id)}>
                                               <Icon icon={trash2Outline} width={24} height={24} color="#ffffff" />
                                             </IconButton>
                                           }
                                         </TableCell>
                                       </TableRow>
                                       {data?.expected_install_labor_cost && data?.expected_install_labor_cost > 0 ? (
                                         <TableRow key={`install-${index}`}>
                                           <TableCell>-</TableCell>
                                           <TableCell align="center">
                                             <Typography variant="body2" sx={{color: "#1ccaff"}}>Install Labor Cost</Typography>
                                           </TableCell>
                                           <TableCell align="center">-</TableCell>
                                           <TableCell align="center">
                                             <Typography variant="body2">
                                               {data?.expected_install_labor_cost.toFixed(2)}
                                             </Typography>
                                           </TableCell>
                                           <TableCell align="center">
                                             <Typography variant="body2">
                                               {data?.expected_install_labor_cost.toFixed(2)}
                                             </Typography>
                                           </TableCell>
                                           <TableCell align="center">
                                             <Typography variant="body2">
                                               ${totalCost.toFixed(2)}
                                             </Typography>
                                           </TableCell>
                                           <TableCell></TableCell>
                                         </TableRow>
                                        ) : ''}
                                        <TableRow>
                                          <TableCell colSpan={7} sx={{ padding: 0 }}>
                                            <Divider />
                                          </TableCell>
                                        </TableRow>
                                      </>
                                    )
                                 })}
                               
                              </TableBody>
                            </Table>
                          </TableContainer>
                         ) : 
                          ""
                         }

                          {/* Split Services Table */}
                          {splitServices && splitServices.length > 0 ? (
                            <>
                              <Typography variant="h6" align="left" sx={{ mt: 3 }}>Split Services</Typography>
                              <TableContainer component={Paper} sx={{ mt: 2 }}>
                                <Table>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>Service Name</TableCell>
                                      <TableCell align="center">Unit Cost</TableCell>
                                      <TableCell align="center">Quantity</TableCell>
                                      <TableCell align="center">Total</TableCell>
                                      <TableCell align="center"></TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {splitServices.map((service, index) => (
                                      <TableRow key={index}>
                                        <TableCell>{service.name || '-'}</TableCell>
                                        <TableCell align="center">
                                          <Typography variant="body2">
                                            ${(service.unit_cost || 0).toFixed(2)}
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                          <Typography variant="body2">
                                            {service.quantity || 0}
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                          <Typography variant="body2">
                                            ${(service.total || 0).toFixed(2)}
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                          {openEdit && (
                                            <IconButton onClick={() => handleRemoveSplitService(service.id)}>
                                              <Icon icon={trash2Outline} width={24} height={24} color="#ffffff" />
                                            </IconButton>
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </>
                          ):''}

                          <Divider />
  
                        
                        {
                          selectedRecipes && selectedRecipes.length > 0 ?
                          <Box sx={{ mb: 2 }}>
                            <Grid container spacing={1} sx={{ maxWidth: 400, ml: 'auto' }}>
                              <Grid item xs={9}>
                                <Typography variant="h6" sx={{ textAlign: 'right' }}>
                                  Total Product Cost :
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="h6" sx={{ textAlign: 'right' }}>
                                  ${productCost.toFixed(2)}
                                </Typography>
                              </Grid>
                              
                              <Grid item xs={9}>
                                <Typography variant="h6" sx={{ textAlign: 'right',pt: 1 }}>
                                  Total Installation Cost :
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="h6" sx={{ textAlign: 'right',pt: 1 }}>
                                  ${installCost.toFixed(2)}
                                </Typography>
                              </Grid>
                              {
                                details?.isFromDesignOrder ?
                                <>
                              <Grid item xs={9}>
                                <Typography variant="h6" sx={{ textAlign: 'right',pt: 1 }}>
                                  Total Service Cost :
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="h6" sx={{ textAlign: 'right',pt: 1 }}>
                                  ${serviceCost.toFixed(2)}
                                </Typography>
                              </Grid>
                                </> :''
                              }
                              
                              <Grid item xs={9}>
                                <Typography variant="h6" sx={{ textAlign: 'right', fontWeight: 'bold', pt: 1 }}>
                                  Grand Total Cost :
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="h6" sx={{ textAlign: 'right', fontWeight: 'bold', pt: 1 }}>
                                  ${totalCost.toFixed(2)}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Box>
                          :""}
                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                          >
                            
                          </Stack>
  
                          
                          <Box
                            sx={{
                              mt: 3,
                              display: 'flex',
                              justifyContent: 'flex-end',
                              gap: 1,
                            }}
                          >
                            {progress != null && progress < 100 ? (
                              <CircularProgress
                                color="primary"
                                variant="determinate"
                                value={progress}
                              />
                            ) : (
                              <>
                              {(details?.status == 5 || details?.status == 2) ?
                                <LoadingButton
                                  variant="contained"
                                  onClick={() => handleSubmitOrder()}
                                >
                                  Submit Order
                                </LoadingButton> :
                                <LoadingButton
                                  type="submit"
                                  variant="contained"
                                  loading={isSubmitting}
                                  disabled={details?.status == 2}
                                >
                                  Save Order
                                </LoadingButton>
                                }
                                <Button
                                  variant="outlined"
                                  onClick={() => handleCancel()}
                                >
                                  Cancel
                                </Button>
                              </>
                            )}
                          </Box>
                        </Stack>
                      </Card>
                    </Grid>
                  </Grid>
                </Form>
              </FormikProvider>
            )}
            {!openEdit && (
              <>
                <Stack
                  direction={'row'}
                  display={'flex'}
                  alignItems={'center'}
                  spacing={{ xs: 3, sm: 2 }}
                >
                  
                      <Link
                        color={theme.palette.success.dark}
                        onClick={() => setOpenInvoice(!openInvoice)}
                        to={''}
                      >
                       
                          <Typography fontSize={'1.09rem'} variant="overline">
                            Details
                          </Typography>
                       
                      </Link>
                  <Typography fontWeight={'0.09rem'} variant="overline">
                    <Label
                      sx={{ p: '12px' }}
                      variant={
                        theme.palette.mode === 'light' ? 'ghost' : 'filled'
                      }
                      color={
                        getStatusColorAndLabel(details?.status, details?.hold)
                          .color
                      }
                    >
                      {
                        getStatusColorAndLabel(details?.status, details?.hold)
                          .label
                      }
                    </Label>
                  </Typography>
  
  {
    (details?.status ==1 && details?.origin_facility_id == currentFacilityId && selectedRecipes?.length > 0 && selectedRecipes?.every(recipe => recipe.recipe_id != null)) ? (
 
                  <Box>
                        <Button
                          size="medium"
                          type="submit"
                          variant="contained"
                          sx={{ mr:1 }}
                          onClick={() => setConfirmInvoice(true)}
                        >
                          Approve
                        </Button>
                        <Button
                          size="medium"
                          variant="outlined"
                          onClick={() => setRejectInvoice(true)}
                          sx={{ color: theme.palette.error.main }}
                        >
                          Reject
                        </Button>
                        </Box>
  ):""}
                  {(userType == 3 || isClient) &&
                  designs?.length > 0 &&
                  details?.hold !== 1 &&
                  details?.send_client_app_req == 1
                    ? !(
                        details?.status == 2 ||
                        details?.status == 3 ||
                        details?.status == 6
                      ) && (
                        // &&
                        // (details?.design_order_job_status == 3)
                        <Box>
                        <Button
                          size="medium"
                          type="submit"
                          variant="contained"
                          sx={{ mr:1 }}
                          onClick={() => setConfirmInvoice(true)}
                        >
                          Approve
                        </Button>
                        <Button
                          size="medium"
                          variant="outlined"
                          onClick={() => setRejectInvoice(true)}
                          sx={{ color: theme.palette.error.main }}
                        >
                          Reject
                        </Button>
                        </Box>
                      )
                    : ''}
  

                </Stack>
  
                <Grid container spacing={3}>
                  <Grid sx={{ mt: 3 }} item xs={12} md={12}>
                    <Stack spacing={3}>
                      <Stack spacing={5}>
                        <Tabs
                          value={currentTab}
                          scrollButtons="auto"
                          variant="scrollable"
                          allowScrollButtonsMobile
                          onChange={handleChangeTab}
                        >
                          {ACCOUNT_TABS.map((tab) => (
                            <Tab
                              disableRipple
                              key={tab.value}
                              label={capitalCase(tab.value)}
                              value={tab.value}
                              sx={{
                                fontWeight:500
                              }}
                            />
                          ))}
                        </Tabs>
  
                        {ACCOUNT_TABS.map((tab) => {
                          const isMatched = tab.value === currentTab
                          return (
                            isMatched && (
                              <Box key={tab.value}>{tab.component}</Box>
                            )
                          )
                        })}
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </>
            )}
            {/* invoice modal */}
            <Modal
              modalTitle={'Order Details'}
              open={openInvoice === true}
              handleClose={() => setOpenInvoice(false)}
            >
              <Stack
                direction={{ xs: 'column', sm: 'row', md: 'column' }}
                spacing={{ xs: 3, sm: 2 }}
              >
                <Stack
                  direction="row"
                  justifyContent={'flex-end'}
                  alignItems="center"
                  spacing={1}
                >
                  <ReactToPrint
                    trigger={() => (
                      <Button>
                        {' '}
                        <Print />
                        Print A3
                      </Button>
                    )}
                    content={() => componentRef.current}
                    copyStyles={false}
                    pageStyle={`
                      @media print {
                        body {
                          font-size: 12pt;
                        }
                        table {
                          width: 100%;
                          border-collapse: collapse;
                          margin-bottom: 10px;
                        }
  
                        th, td {
                          border: 1px solid #ddd;
                          padding: 5px;
                          text-align: left;
                        }
                        #right {
                          text-align: right;
                          margin-top: -200px; 
                        }
                        #total {
                          text-align: right;
                          display:flex;
                          justify-content: flex-end;
                        }
                        #subtotal {
                          text-align: left;
                          
                        }
                        #discount {
                          text-align: left;
                          word-wrap: break-word;
                          margin-right: 100px;
                      }
                      
                        #totalmain {
                          text-align: left;
                          
                        }
                        #subtotal1 {
                          text-align: left;
                          
                        }
                        #discount1 {
                          text-align: left;
                          word-wrap: break-word;
                          margin-right: 30px;
                      }
                      
                        #totalmain1 {
                          text-align: left;
                          
                        }
                        #total1 {
                          text-align: right;
                          display:flex;
                          justify-content: flex-end;
                          margin-top: -220px; 
                          
                        }
                        .split-estimate-heading-print {
                          text-align: center;
                          width: 100%;
                          position: absolute;
                          left: 0;
                          right: 0;
                        }
                        #logoImage {
                          height: 100px;
                          width:100px;
                        }
                        #order{
                          margin-bottom:-20px
                        }
                        #title{
                          margin-bottom:-20px
                        }
                        #orderID {
                          margin-bottom:-20px
                        }
                        #to {
                          margin-bottom:-20px
                        }
                        
                      }
                    `}
                  />
                  {(details?.status === 4 || details?.status === 3) &&
                    SEND_EMAIL && (
                      <Button onClick={handleSendEmail}>Send Email</Button>
                    )}
                  <div style={{ display: 'none' }}>
                    <PrintFunction
                      invoiceDate={invoiceDate}
                      openInvoice={openInvoice}
                      details={details}
                      invoice={invoice}
                      ref={componentRef}
                      data={data}
                      selectedRecipes={selectedRecipes}
                      splitServices={splitServices}
                      splitPercentage={splitPercentage}
                      productCost={productCost}
                      installCost={installCost}
                      serviceCost={serviceCost}
                      totalCost={totalCost}
                    />
                  </div>
                </Stack>
              </Stack>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                  <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                    <Box
                      component="img"
                      alt="logo"
                      src={COMPANY_LOGO}
                      sx={{ height: 98 }}
                    />
                  </Grid>
                  <Typography variant="body2">{COMPANY_NAME}</Typography>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.company_website}</Typography>
                  <Typography variant="body2">
                    {data?.address}, {data?.city}, {data?.state}, {data?.zipcode}
                  </Typography>
                  {/* <Typography variant="body2">Telephone: +15208362947</Typography> */}
                  <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                    <Typography variant="body2" sx={{ textTransform: 'uppercase', }}>Telephone: {(data?.phone_country_code || data?.phone) ? `+${data?.phone_country_code}${data?.phone}` : '951-682-9660'}</Typography>
                    <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>|</Typography>
                    <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.company_fax_number ? `Fax: ${data?.company_fax_number}` : ''}</Typography>
                  </Box>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.company_mail}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                  <Typography variant="body2">
                    Order date: {invoiceDate}
                  </Typography>
                  <Label
                    variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                    color={
                      getStatusColorAndLabel(details?.status, details?.hold).color
                    }
                  >
                    {getStatusColorAndLabel(details?.status, details?.hold).label}
                  </Label>
                  {/* </Stack> */}
                  <Typography variant="body2">
                    Order Name:{details?.name}
                  </Typography>
                  <Typography variant="body2">Order ID:{details?.id}</Typography>
                  <Typography
                    paragraph
                    variant="overline"
                    sx={{ color: '#ffffff', marginTop: '20px' }}
                  >
                    TO {invoice?.customer_name}
                  </Typography>
                  <Typography variant="body2">
                    Phone: {invoice?.customer_phone}
                  </Typography>
                </Grid>
              </Grid>

              <Typography variant="h6" align="left">  { selectedRecipes && selectedRecipes.length > 0 ? "Product Formulas" : ""}</Typography>
              <Stack
          direction={{ xs: 'row', sm: 'row' }}
          spacing={{ xs: 3, sm: 2 }}
        >
                      { selectedRecipes && selectedRecipes.length > 0 ? (
                            <>
                          <TableContainer component={Paper} sx={{ mt: 2 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Product</TableCell>
                                  <TableCell>Formula</TableCell>
                                  <TableCell>Outgoing Percentage</TableCell>
                                  <TableCell>Actual Cost</TableCell>
                                  <TableCell>
                                    <Tooltip title="Actual Cost + Outgoing Percentage" arrow>
                                      <Typography variant="subtitle2">Split Retail Cost</Typography>
                                    </Tooltip>
                                  </TableCell>
                                  <TableCell>
                                    <Tooltip title="Product Cost + Install Cost" arrow>
                                      <Typography variant="subtitle2">Total Cost</Typography>
                                    </Tooltip>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedRecipes.map((data, index) => {
                                  data.name = data?.name || data?.recipe_name
                                  data.recipe_id = data?.recipe_id
                                  
                                  // Calculate total_cost = expected_cost + (expected_cost * splitPercentage / 100)
                                  const expectedCost = data?.expected_cost || 0;
                                  // const splitAmount = expectedCost * (splitPercentage / 100);
                                  // const totalCost = parseFloat((expectedCost + splitAmount).toFixed(2));
                                    let expectedCostWithoutInstallLaborCost = expectedCost;
                                  const safeSplitPercentage = splitPercentage || 0;
                                  const splitAmount = expectedCostWithoutInstallLaborCost * (safeSplitPercentage / 100);
                                  const totalCost = parseFloat((expectedCost + splitAmount + (data?.expected_install_labor_cost || 0)).toFixed(2));
                                  const expectedCostWithInstallLaborCost = expectedCost + (data?.expected_install_labor_cost || 0);
                                  const lineTotalwithoutInstall = parseFloat((expectedCost + splitAmount).toFixed(2)); 
                                  return (
                                     <>
                                       <TableRow key={index}>
                                         <TableCell>{data?.product_name || '-'}</TableCell>
                                         <TableCell>
                                           <Tooltip title={data?.name || '-'} arrow>
                                             <Typography variant="body2" sx={{ 
                                               maxWidth: 200, 
                                               overflow: 'hidden', 
                                               textOverflow: 'ellipsis',
                                               whiteSpace: 'nowrap'
                                             }}>
                                               {(data?.name || '-').length > 30 ? `${(data?.name || '-').substring(0, 30)}...` : (data?.name || '-')}
                                             </Typography>
                                           </Tooltip>
                                         </TableCell>
                                         <TableCell>
                                           <Typography alignItems={'center'} variant="body2">
                                             {(splitPercentage || 0)}%
                                           </Typography>
                                         </TableCell>
                                         <TableCell>
                                           <Typography variant="body2">
                                             {(expectedCost).toFixed(2)}
                                           </Typography>
                                         </TableCell>
                                         <TableCell>
                                          {/* {data?.expected_install_labor_cost == null || data?.expected_install_labor_cost <= 0 ? */}
                                           <Tooltip title={`${expectedCost.toFixed(2)}  + ${splitAmount.toFixed(2)} = ${lineTotalwithoutInstall.toFixed(2)}`} arrow>
                                             <Typography variant="body2">
                                               ${lineTotalwithoutInstall.toFixed(2)}
                                             </Typography>
                                           </Tooltip>
                                           {/* :'-'} */}
                                         </TableCell>
                                         <TableCell>
                                           {data?.expected_install_labor_cost && data?.expected_install_labor_cost > 0 ? (
                                             <Typography variant="body2">
                                               -
                                             </Typography>
                                           ) : (
                                             <Typography variant="body2">
                                               ${totalCost.toFixed(2)}
                                             </Typography>
                                           )}
                                         </TableCell>
                                       </TableRow>
                                       {data?.expected_install_labor_cost && data?.expected_install_labor_cost > 0 ? (
                                         <TableRow key={`install-modal-${index}`}>
                                           <TableCell>-</TableCell>
                                           <TableCell>
                                             <Typography variant="body2" sx={{color: "#1ccaff"}}>Install Labor Cost</Typography>
                                           </TableCell>
                                           <TableCell>-</TableCell>
                                           <TableCell>
                                             <Typography variant="body2">
                                               {data?.expected_install_labor_cost.toFixed(2)}
                                             </Typography>
                                           </TableCell>
                                           <TableCell>
                                             <Typography variant="body2">
                                               {data?.expected_install_labor_cost.toFixed(2)}
                                             </Typography>
                                           </TableCell>
                                           <TableCell>
                                             <Typography variant="body2">
                                               ${totalCost.toFixed(2)}
                                             </Typography>
                                           </TableCell>
                                         </TableRow>
                                        ):''}
                                        <TableRow>
                                          <TableCell colSpan={6} sx={{ padding: 0 }}>
                                            <Divider />
                                          </TableCell>
                                        </TableRow>
                                      </>
                                    )
                                 })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        
                         </>
                         ) : 
                          ""
                         }

            </Stack>
              {/* Split Services Table in Modal */}
              {splitServices && splitServices.length > 0 ? (
                <>
                  <Typography variant="h6" align="left" sx={{ mt: 3 }}>Split Services</Typography>
                  <TableContainer component={Paper} sx={{ mt: 2 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Service Name</TableCell>
                          <TableCell align="center">Unit Cost</TableCell>
                          <TableCell align="center">Quantity</TableCell>
                          <TableCell align="center">Total</TableCell>
                          <TableCell align="center"></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {splitServices.map((service, index) => (
                          <TableRow key={index}>
                            <TableCell>{service.name || '-'}</TableCell>
                            <TableCell align="center">
                              <Typography variant="body2">
                                ${(service.unit_cost || 0).toFixed(2)}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Typography variant="body2">
                                {service.quantity || 0}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Typography variant="body2">
                                ${(service.total || 0).toFixed(2)}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              {openEdit && (
                                <IconButton onClick={() => handleRemoveSplitService(service.id)}>
                                  <Icon icon={trash2Outline} width={24} height={24} color="#ffffff" />
                                </IconButton>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ):''}
            <Box sx={{ mb: 2,marginRight:2,mt:1 }}>
              <Grid container spacing={1} sx={{ maxWidth: 400, ml: 'auto' }}>
                <Grid item xs={9}>
                  <Typography variant="subtitle1" sx={{ textAlign: 'right', pt: 1 }}>
                    Total Product Cost :
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1" sx={{ textAlign: 'right', pt: 1 }}>
                    ${productCost.toFixed(2)}
                  </Typography>
                </Grid>
                
                <Grid item xs={9}>
                  <Typography variant="subtitle1" sx={{ textAlign: 'right', pt: 1 }}>
                    Total Installation Cost :
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1" sx={{ textAlign: 'right', pt: 1 }}>
                    ${installCost.toFixed(2)}
                  </Typography>
                </Grid>
                {
                  details?.isFromDesignOrder  ?
                  <>
                <Grid item xs={9}>
                  <Typography variant="subtitle1" sx={{ textAlign: 'right', pt: 1 }}>
                    Total Service Cost :
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1" sx={{ textAlign: 'right', pt: 1 }}>
                    ${serviceCost.toFixed(2)}
                  </Typography>
                </Grid>
                  </>
                  :''
                }
                
                <Grid item xs={9}>
                  <Typography variant="subtitle1" sx={{ textAlign: 'right', fontWeight: 'bold', pt: 1 }}>
                    Grand Total Cost :
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1" sx={{ textAlign: 'right', fontWeight: 'bold', pt: 1 }}>
                    ${totalCost.toFixed(2)}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

              <Typography
                variant="subtitle1"
                sx={{ textAlign: 'center', color: '#ffffff', p: 3 }}
              >
                {/* {designs?.length > 0 ? "Designs" : "No designs uploaded"} */}
                {( (userType === 3 || isClient ) ? details?.send_client_app_req : designs?.length > 0 ) ? 'Files' : 'No Files uploaded'}
              </Typography>
              {selectedDesignsForEmail.length > 0 && (
                <Box display="flex" justifyContent="flex-end" mb={2} sx={{ pr: 2 }}>
                  <Tooltip title={`Send ${selectedDesignsForEmail.length} design${selectedDesignsForEmail.length !== 1 ? 's' : ''} to email`}>
                    <Badge badgeContent={selectedDesignsForEmail.length} color="error">
                      <IconButton
                        color="primary"
                        onClick={handleSendSelectedDesignsToEmail}
                        sx={{
                          backgroundColor: (theme) => theme.palette.primary.main,
                          color: (theme) => theme.palette.primary.contrastText,
                          '&:hover': {
                            backgroundColor: (theme) => theme.palette.primary.dark,
                          },
                        }}
                      >
                        <Icon icon={emailFillIcon} width={24} height={24} />
                      </IconButton>
                    </Badge>
                  </Tooltip>
                </Box>
              )}
              <Grid container spacing={2}>
                <Scrollbar>
                  {/* {designs?.length > 0 ? ( */}
                  {(
                   ( userType === 3 || isClient)
                      ? details?.send_client_app_req
                      : designs?.length > 0
                  ) ? (
                    // <Box sx={{border: '0.1px solid', borderColor: borderColor,padding:2, }}>
                    //   <Scrollbar sx={{ width: '100%', height: 450 }}>
                    <ImageList
                      gap={16}
                      cols={mdd ? 2 : xld ? 4 : xs ? 1 : 3}
                      sx={{
                        padding: 2,
                        '& .MuiImageListItem-root': {
                          borderRadius: '8px',
                          overflow: 'hidden',
                        }
                      }}
                    >
                      {filteredDesigns?.map((item) => {
                        const { file_type, name, url, extension } = item
                        const fileUrl = url || name || ''
                        const lowerFileUrl = String(fileUrl).toLowerCase()
                        // const isPdf = file_type === 'application/pdf' || extension=='pdf';
                        if (item.approved !== 1 && isClient) return;
                        const isImage =
                          file_type?.startsWith('image/') ||
                          file_type === 'img' ||
                          file_type === 'image' ||
                          extension?.toLowerCase() === 'png' ||
                          extension?.toLowerCase() === 'jpg' ||
                          extension?.toLowerCase() === 'jpeg' ||
                          extension?.toLowerCase() === 'gif' ||
                          extension?.toLowerCase() === 'bmp' ||
                          extension?.toLowerCase() === 'webp' ||
                          extension?.toLowerCase() === 'svg' ||
                          lowerFileUrl.includes('.png') ||
                          lowerFileUrl.includes('.jpg') ||
                          lowerFileUrl.includes('.jpeg') ||
                          lowerFileUrl.includes('.gif') ||
                          lowerFileUrl.includes('.bmp') ||
                          lowerFileUrl.includes('.webp') ||
                          lowerFileUrl.includes('.svg')
                        const isPdf =
                          file_type === 'application/pdf' ||
                          file_type === "other" ||
                          file_type === "pdf" ||
                          extension?.toLowerCase() === 'pdf' ||
                          lowerFileUrl.includes('.pdf')
                        const isSelectedForEmail = selectedDesignsForEmail?.includes(item.id);
                        const handleToggleEmail = () => {
                          setSelectedDesignsForEmail((prev) =>
                            isSelectedForEmail ? prev?.filter((n) => n !== item.id) : [...prev, item.id],
                          )
                        }
                        return (
                          <ImageListItem key={item.name} sx={{
                            cursor:'pointer',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            position: 'relative',
                            '&:hover': {
                              transform: 'scale(1.02)',
                              transition: 'transform 0.2s ease-in-out',
                            }
                          }}>
                            <Box position="relative">
                              <Checkbox
                                checked={isSelectedForEmail}
                                onChange={handleToggleEmail}
                                onClick={(e) => e.stopPropagation()}
                                sx={{
                                  position: 'absolute',
                                  top: 8,
                                  left: 8,
                                  zIndex: 10,
                                  color: 'black',
                                  backgroundColor: theme.palette.grey.A700,
                                  boxShadow: 1
                                }}
                              />
                            </Box>
                            {isImage ? (
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleImageClick(imageDesigns.findIndex((img) => img.name === name))
                                }}
                              >
                                <img
                                  srcSet={`${fileUrl}?w=240&h=240&fit=crop&auto=format&dpr=2 2x`}
                                  src={`${fileUrl}?w=240&h=240&fit=crop&auto=format`}
                                  alt={item.title}
                                  loading="lazy"
                                  style={{ 
                                    width: '100%', 
                                    height: '240px', 
                                    cursor: 'pointer',
                                    objectFit: 'cover',
                                    borderRadius: '8px 8px 0 0'
                                  }}
                                />
                              </a>
                            ) : isPdf ? (
                              <Box 
                                display="flex" 
                                alignItems="center" 
                                justifyContent="center"
                                sx={{
                                  position: 'relative',
                                  width: '100%',
                                  height: '240px',
                                  backgroundColor: '#f5f5f5',
                                  borderRadius: '8px 8px 0 0',
                                  overflow: 'hidden'
                                }}
                              >
                                {/* PDF Icon Button */}
                                <Tooltip title='View'>
                                  <IconButton 
                                    onClick={() => {
                                      setPdfLoading(true);
                                      setSelectedPDF(fileUrl);
                                      setSelectedPDFItem(item);
                                      setOpenPDFModal(true);
                                    }}
                                    aria-label="open pdf"
                                    sx={{ 
                                      position:'absolute', 
                                      top: '50%',
                                      left: '50%',
                                      transform: 'translate(-50%, -50%)',
                                      zIndex: 200,
                                      color:theme.palette.error.main, 
                                      backgroundColor:theme.palette.text.primary,
                                      '&:hover': {
                                        backgroundColor: theme.palette.text.secondary,
                                      }
                                    }} 
                                  >
                                    <PictureAsPdf style={{ fontSize: 40 }} />
                                  </IconButton>
                                </Tooltip>
                    
                                {/* PDF Preview Background */}
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '8px 8px 0 0',
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: theme.palette.text.secondary,
                                      fontSize: '12px',
                                      position: 'absolute',
                                      bottom: 8,
                                      left: 8,
                                    }}
                                  >
                                    PDF Document
                                  </Typography>
                                </Box>
  
                                <DialogAnimate
                                  open={openPDFModal}
                                  onClose={() => setOpenPDFModal(false)}
                                >
                                  <Card className={classes.dialogContent}>
                                    <div style={{width:'90%', display:'flex',justifyContent:'space-between', marginBottom: '15px',marginLeft:'25px' }}>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          onClick={() => handleSendCurrentItemToEmail(selectedPDFItem)}
                                          disabled={!selectedPDFItem}
                                          startIcon={<Icon icon={emailFillIcon} width={20} height={20} />}
                                          sx={{
                                            fontSize:'14px'
                                          }}
                                        >
                                          Send to Email
                                        </Button>
                                        <Button
                                          variant="outlined"
                                          color="primary"
                                          onClick={() => window.open(selectedPDF, '_blank')}
                                          disabled={!selectedPDF}
                                          startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                          sx={{
                                            fontSize:'14px'
                                          }}
                                        >
                                          View PDF
                                        </Button>
                                    </div>
                                    {pdfLoading && (
                                      <Skeleton
                                        variant="rectangular"
                                        width="100%"
                                        height={500}
                                      />
                                    )}
  
                                    <iframe
                                      src={selectedPDF}
                                      title="Selected PDF"
                                      width="100%"
                                      height="500px"
                                      frameBorder="0"
                                      style={{
                                        display: pdfLoading ? 'none' : 'block',
                                      }}
                                      onLoad={() => setPdfLoading(false)}
                                    />
                                  </Card>
                                </DialogAnimate>
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: '100%',
                                  height: '240px',
                                  backgroundColor: theme.palette.grey[100],
                                  borderRadius: '8px 8px 0 0',
                                  border: `1px solid ${theme.palette.grey[300]}`
                                }}
                              >
                                <Typography 
                                  sx={{
                                    color: theme.palette.error.main,
                                    textAlign: 'center'
                                  }}
                                >
                                  Unsupported file type
                                </Typography>
                              </Box>
                            )}
                          </ImageListItem>
                        )
                      })}
                    </ImageList>
                  ) : (
                    //   </Scrollbar>
                    // </Box>
                    ''
                  )}
                </Scrollbar>
              </Grid>
              <Grid container spacing={2}>
                <Scrollbar>
                  {((userType == 3 || isClient) || accessForApproveEstimateForClient || isAdminUser (userType)) &&
                  designs?.length > 0 &&
                  details?.send_client_app_req == 1
                    ? !(
                        details?.status == 2 ||
                        details?.status == 3 ||
                        details?.status == 6
                      ) && (
                        // &&
                        // (details?.design_order_job_status == 3)
                        <Box
                          sx={{
                            mt: 3,
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 1,
                          }}
                        >
                          {confirmInvoice ? (
                            <Stack alignItems="center" justifyContent="center">
                              <CircularProgress
                                color="primary"
                                variant="indeterminate"
                              />
                            </Stack>
                          ) : (
                            <Button
                              type="submit"
                              variant="contained"
                              onClick={() => setConfirmInvoice(true)}
                            >
                              {isAdminUser (userType) ? 'Approve For Client' : 'Approve'}
                            </Button>
                          )}
                          {invoiceReject ? (
                            <Stack alignItems="center" justifyContent="center">
                              <CircularProgress
                                color="primary"
                                variant="indeterminate"
                              />
                            </Stack>
                          ) : (
                            <>
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() => setRejectInvoice(true)}
                                sx={{ color: theme.palette.error.main }}
                              >
                                Reject
                              </Button>
                            </>
                          )}
                        </Box>
                      )
                    : ''}
                </Scrollbar>
              </Grid>
            </Modal>
            <Modal width={1000}
              open={openImageModal}
              handleClose={() => {
                setOpenImageModal(false);
              }}
              modalTitle={'Designs'}
              >
              <Stack spacing={2}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleSendCurrentItemToEmail(imageDesigns[currentImageIndex])}
                    disabled={!imageDesigns || imageDesigns.length === 0 || currentImageIndex === null}
                    startIcon={<Icon icon={emailFillIcon} width={20} height={20} />}
                  >
                    Send to Email
                  </Button>
                </Box>
              <div
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'flex',
                gap:'1rem',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
            {/* <IconButton
              onClick={handlePrevious}
              disabled={currentImageIndex === 0}
              sx={{
                opacity: currentImageIndex === 0 ? 0.3 : 1,
                pointerEvents: currentImageIndex === 0 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowLeftOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton> */}
  
            <Box
            component={'div'} 
              style={{
                width: '500px',
                height: '500px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 8,
                overflow: 'hidden',
              }}
            >
              <img
                src={imageDesigns[currentImageIndex]?.url}
                alt={`Image ${currentImageIndex + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 8,
                }}
              />
            </Box>
            {/* <IconButton
              onClick={handleNext}
              disabled={currentImageIndex === imageDesigns.length - 1}
              sx={{
                opacity: currentImageIndex === imageDesigns.length - 1 ? 0.3 : 1,
                pointerEvents: currentImageIndex === imageDesigns.length - 1 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowRightOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton> */}
          </div>
          </Stack>
        </Modal>
            <ConfirmationPopup
              open={openDelete}
              handleClick={handleDeleteOrder}
              handleClose={() => {
                setOpenDelete(!openDelete), setIsOpen(false)
              }}
              message={'You want to delete this order '}
            />
  
            <ConfirmationPopup
              open={openConvertToSalesOrder}
              handleClick={handleConvertToSalesOrder}
              handleClose={() => {
                setOpenConvertToSalesOrder(false)
              }}
              message={
                'This Design Order will be converted and moved to Sales Order Page '
              }
            />
            <ConfirmationPopup
              open={openConvertToEstimate}
              handleClick={handleConvertToEstimate}
              handleClose={() => {
                setOpenConvertToEstimate(false)
                setIsConvertToSalesOrder(false)
              }}
              message={
                `This Split Estimate will be converted and moved to ${isConvertToSalesOrder ? 'Sales Order Page' : 'Estimate Page'} `
              }
            />
  
            <ConfirmationPopup
              isapproveOrder={true}
              open={confirmInvoice}
              loading={isLoading} // ✅ only passed here
              handleClick={async () => {
                setIsLoading(true);
                await handleAcceptorRejectInvoice(2);
                setIsLoading(false);
              }}
              handleClose={() => setConfirmInvoice(false)}
              // message={'You want to Approve this Order '}
              message={'Do you Approve this Order ? '}
            />
            <ConfirmationPopup
              open={reOpen}
              handleClick={() => handleReopeningRequest()}
              handleClose={() => setReopen(false)}
              message={'You want to reopen this Order '}
            />
            {/* Preview Modal */}
            {openPreview && (
              <Modal
                width={900}
                open={openPreview}
                handleClose={() => {
                  setOpenPreview(false)
                }}
                modalTitle={'Preview'}
              >
                {/* <ReactToPrint
                  trigger={() => (
                    <Button variant="contained" color="primary">
                      Print A3
                    </Button>
                  )}
                  content={() => printableContentRef.current}
                  pageStyle={`@media print {
                    .print-black {
                      color: black !important;
                      background:white !important
                    }
                    table {
                      width: 100%;
                      border-collapse: collapse;
                      margin-bottom: 10px;
                    }
                    * {
                      color: black !important;
                      background-color: white !important;
                    }
                    .MuiTableCell-root {
                      color: black !important;
                    }
                    .MuiInputBase-input {
                      color: black !important;
                    }
                    .no-scrollbar::-webkit-scrollbar {
                      display: none;
                    }
                    .no-scrollbar {
                      -ms-overflow-style: none;
                      scrollbar-width: none;
                    }
                    .enable-for-print {
                      pointer-events: auto;
                      color: black !important;
                    }
                    .print-black .enable-for-print input[type='number'],
                    .print-black .enable-for-print input[type='text'] {
                      color: black !important;
                    }
                    .css-wr96yv-MuiInputBase-input-MuiOutlinedInput-input {
                    color: black !important;
                    opacity: 1;
                      -webkit-text-fill-color:black !important;
                    }
                    input[type=number]{
                      color:black !important}
                    }`}
                /> */}
                <div ref={printableContentRef} className="print-black">
                  <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
                    <Grid item xs={12} md={12}>
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                        }}
                        spacing={2}
                      >
                        <Stack
                          direction={{ xs: 'column', md: 'row' }}
                          display="flex"
                          justifyContent="space-between"
                        >
                          <Typography variant="subtitle2">
                            <span style={{ color: theme.palette.primary.darker }}>
                            Formula:{' '}
                            </span>
                            {previewData?.name}
                          </Typography>
  
                          <Typography variant="subtitle2">
                            <span style={{ color: theme.palette.primary.darker }}>
                              Use custom welcome message:{' '}
                            </span>
                            {previewData.welcome_message == null
                              ? 'No'
                              : previewData.welcome_message == false
                              ? 'No'
                              : 'Yes'}
                          </Typography>
                        </Stack>
                        <Stack>
                          <Typography
                            variant="subtitle2"
                            style={{ color: theme.palette.primary.darker }}
                          >
                            Description:
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            style={{
                              overflowWrap: 'break-word',
                              wordWrap: 'break-word',
                              wordBreak: 'break-word',
                              whiteSpace: 'pre-line',
                            }}
                          >
                            {previewData?.description}
                          </Typography>
                        </Stack>
                        <Stack
                          direction={{ xs: 'column', md: 'row' }}
                          display="flex"
                          justifyContent="space-between"
                        ></Stack>
  
                        <Stack
                          direction={{ xs: 'column', md: 'row' }}
                          display="flex"
                          justifyContent="space-between"
                        >
                          <Typography variant="subtitle2">
                            <span style={{ color: theme.palette.primary.darker }}>
                              Client:{' '}
                            </span>
                            {previewData?.clients?.name}
                          </Typography>
                        </Stack>
                        <Stack
                          direction={{ xs: 'column', md: 'row' }}
                          display="flex"
                          justifyContent="space-between"
                        >
                          <Typography variant="subtitle2">
                            <span style={{ color: theme.palette.primary.darker }}>
                              Start Date:{' '}
                            </span>
                            {moment.unix(previewData.start).format('MM/DD/YYYY')}
                          </Typography>
                          <Typography variant="subtitle2">
                            <span style={{ color: theme.palette.primary.darker }}>
                              Due Date:{' '}
                            </span>
                            {moment.unix(previewData.end).format('MM/DD/YYYY')}
                          </Typography>
                        </Stack>
                        <Stack>
                          <Typography
                            variant="subtitle2"
                            style={{ color: theme.palette.primary.darker }}
                          >
                            Notes:
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              overflowWrap: 'break-word',
                              wordWrap: 'break-word',
                              wordBreak: 'break-word',
                              color: 'error.main',
                              whiteSpace: 'pre-line'
                            }}
                          >
                            <Scrollbar
                              sx={{
                                maxHeight: 200,
                                '& .simplebar-content': {
                                  maxHeight: 200,
                                  display: 'flex',
                                  flexDirection: 'column',
                                },
                              }}
                            >
                              {previewData?.notes}
                            </Scrollbar>
                          </Typography>
                        </Stack>
                        <Stack
                          direction={{ xs: 'column', md: 'row' }}
                          display="flex"
                          justifyContent="space-between"
                        >
                          <Typography variant="subtitle2">
                            <Label
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                              color={
                                getStatusColorAndLabel(
                                  details?.status,
                                  details?.hold,
                                ).color
                              }
                            >
                              {
                                getStatusColorAndLabel(
                                  details?.status,
                                  details?.hold,
                                ).label
                              }
                            </Label>
                          </Typography>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                </div>
              </Modal>
            )}
            {/* reject request invoice */}
            {invoiceReject == true && (
              <Dialog
                open={invoiceReject}
                onClose={() => {
                  setRejectInvoice(false)
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                BackdropComponent={Backdrop}
                BackdropProps={{ invisible: true }}
              >
                <DialogTitle id="alert-dialog-title">
                  {'Are you sure ?'}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    You want to reject this Order
                  </DialogContentText>
                  <TextField
                    sx={{ width: 400 }}
                    label="Reason For Rejection"
                    type="text"
                    multiline
                    minRows={3}
                    maxRows={7}
                    onInput={(event) => setReason(event.target.value)}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={async () => {
                      setIsSubmittingReject(true);
                      await handleAcceptorRejectInvoice(3);
                      setIsSubmittingReject(false);
                    }}
                    disabled={isSubmittingReject}
                    sx={{ color: theme.palette.background.paper }}
                  >
                    {isSubmittingReject ? <CircularProgress size={20} color="inherit" /> : 'OK'}
                  </Button>
  
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      setRejectInvoice(false), setReason('')
                    }}
                    sx={{ color: theme.palette.error.main }}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>
            )}
            {/* reject request invoice */}
  
            <Modal
              modalTitle={'Select designs to send for client approval'}
              open={openDesignSelect === true}
              handleClose={() => setOpenDesignSelect(false)}
            >
              <ImageList
                gap={16}
                cols={mdd ? 2 : xld ? 4 : xs ? 1 : 3}
                sx={{
                  padding: 2,
                  '& .MuiImageListItem-root': {
                    borderRadius: '8px',
                    overflow: 'hidden',
                  }
                }}
              >
                {designs?.map((item, index) => {
                  const { file_type, name, url, id, extension } = item
                  const fileUrl = url || name || ''
                  const lowerFileUrl = String(fileUrl).toLowerCase()
                  // const isPdf = file_type === 'application/pdf' || extension=='pdf';
                  const isImage =
                    file_type?.startsWith('image/') ||
                    file_type === 'img' ||
                    file_type === 'image' ||
                    extension?.toLowerCase() === 'png' ||
                    extension?.toLowerCase() === 'jpg' ||
                    extension?.toLowerCase() === 'jpeg' ||
                    extension?.toLowerCase() === 'gif' ||
                    extension?.toLowerCase() === 'bmp' ||
                    extension?.toLowerCase() === 'webp' ||
                    extension?.toLowerCase() === 'svg' ||
                    lowerFileUrl.includes('.png') ||
                    lowerFileUrl.includes('.jpg') ||
                    lowerFileUrl.includes('.jpeg') ||
                    lowerFileUrl.includes('.gif') ||
                    lowerFileUrl.includes('.bmp') ||
                    lowerFileUrl.includes('.webp') ||
                    lowerFileUrl.includes('.svg')
                  const isPdf =
                    file_type === 'application/pdf' ||
                    file_type === "other" ||
                    file_type === "pdf" ||
                    extension?.toLowerCase() === 'pdf' ||
                    lowerFileUrl.includes('.pdf')
  
                  const isSelected = selectedDesigns?.includes(id)
                  const handleToggle = () => {
                    setSelectedDesigns((prev) =>
                      isSelected ? prev?.filter((n) => n !== id) : [...prev, id],
                    )
                  }
                  return (
                    <ImageListItem key={index} sx={{
                      cursor:'pointer',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      '&:hover': {
                        transform: 'scale(1.02)',
                        transition: 'transform 0.2s ease-in-out',
                      }
                    }}>
                      <Box position="relative">
                        <Checkbox
                          checked={isSelected}
                          onChange={handleToggle}
                          sx={{
                            position: 'absolute',
                            top: 8,
                            left: 8,
                            zIndex: 1,
                            color: 'black',
                            backgroundColor: theme.palette.grey.A700,
                            boxShadow: 1 // Optional: helps make it stand out
                          }}
                        />
                          {/* <Box sx={{
                            position: 'absolute',
                            bottom: 8,
                            right: 8,
                            zIndex: 1,
                            color: 'black',
                            backgroundColor: theme.palette.grey.A700,
                            boxShadow: 1 // Optional: helps make it stand out
                          }}>
                            {item.approved === 1 ?(
                              <Label
                                variant={'filled'}
                                color={'success'}
                                style={{ color: 'white', height: 20, width: 100 }}
                              >
                                {'Approved'}
                              </Label>                       
                            ): 
                            item.reason ? (
                              <Label
                              variant={'filled'}
                              color={'error'}
                              style={{ color: 'white', height: 20, width: 100 }}
                              >
                              {'Rejected'}
                            </Label>
                            ):null}
                          </Box> */}
                        {isImage ? (
                          <a
                            // href={name}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => {
                              e.preventDefault();
                              handleImageClick(imageDesigns.findIndex((img) => img.name === name))
                            }}
                          >
                          <img
                            srcSet={`${fileUrl}?w=240&h=240&fit=crop&auto=format&dpr=2 2x`}
                            src={`${fileUrl}?w=240&h=240&fit=crop&auto=format`}
                            alt={item.title}
                            loading="lazy"
                            style={{ 
                              width: '100%', 
                              height: '240px', 
                              cursor:'pointer',
                              objectFit: 'cover',
                              borderRadius: '8px 8px 0 0'
                            }}
                          />
                          </a>
                        ) : isPdf ? (
                          <Box 
                            display="flex" 
                            alignItems="center" 
                            justifyContent="center"
                            sx={{
                              position: 'relative',
                              width: '100%',
                              height: '240px',
                              backgroundColor: '#f5f5f5',
                              borderRadius: '8px 8px 0 0',
                              overflow: 'hidden'
                            }}
                          >
                            {/* PDF Icon Button */}
                            <Tooltip title='View'>
                              <IconButton 
                                onClick={() => {
                                  setPdfLoading(true);
                                  setSelectedPDF(fileUrl);
                                  setSelectedPDFItem(item);
                                  setOpenPDFModal(true);
                                }}
                                aria-label="open pdf"
                                sx={{ 
                                  position:'absolute', 
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                  zIndex: 200,
                                  color:theme.palette.error.main, 
                                  backgroundColor:theme.palette.text.primary,
                                  '&:hover': {
                                    backgroundColor: theme.palette.text.secondary,
                                  }
                                }} 
                              >
                                <PictureAsPdf style={{ fontSize: 40 }} />
                              </IconButton>
                            </Tooltip>
                    
                            {/* PDF Preview Background */}
                            <Box
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '8px 8px 0 0',
                              }}
                            >
                              <Typography
                                variant="caption"
                                sx={{
                                  color: theme.palette.text.secondary,
                                  fontSize: '12px',
                                  position: 'absolute',
                                  bottom: 8,
                                  left: 8,
                                }}
                              >
                                PDF Document
                              </Typography>
                            </Box>
  
                            <DialogAnimate
                              open={openPDFModal}
                              onClose={() => setOpenPDFModal(false)}
                            >
                              <Card className={classes.dialogContent}>
                                <div style={{width:'90%', display:'flex',justifyContent:'space-between', marginBottom: '15px',marginLeft:'25px' }}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleSendCurrentItemToEmail(selectedPDFItem)}
                                    disabled={!selectedPDFItem}
                                    startIcon={<Icon icon={emailFillIcon} width={20} height={20} />}
                                    sx={{
                                      fontSize:'14px'
                                    }}
                                  >
                                    Send to Email
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => window.open(selectedPDF, '_blank')}
                                    disabled={!selectedPDF}
                                    startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                    sx={{
                                      fontSize:'14px'
                                    }}
                                  >
                                    View PDF
                                  </Button>
                                </div>
                                {pdfLoading && (
                                  <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={500}
                                  />
                                )}
  
                                <iframe
                                  src={selectedPDF}
                                  title="Selected PDF"
                                  width="100%"
                                  height="500px"
                                  frameBorder="0"
                                  style={{
                                    display: pdfLoading ? 'none' : 'block',
                                  }}
                                  onLoad={() => setPdfLoading(false)}
                                />
                              </Card>
                            </DialogAnimate>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '100%',
                              height: '240px',
                              backgroundColor: theme.palette.grey[100],
                              borderRadius: '8px 8px 0 0',
                              border: `1px solid ${theme.palette.grey[300]}`
                            }}
                          >
                            <Typography 
                              sx={{
                                color: theme.palette.error.main,
                                textAlign: 'center'
                              }}
                            >
                              Unsupported file type
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </ImageListItem>
                  )
                })}
              </ImageList>
              <Box mt={2} display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                disabled={selectedDesigns.length === 0}
                onClick={() => handleSendClientApproveReq(selectedDesigns)}
              >
                Send for Approval
              </Button>
            </Box>
            </Modal>
            <Dialog open={showApprovalPopup} onClose={() => setShowApprovalPopup(false)}>
              <DialogTitle>Confirm Design Order Changes</DialogTitle>
              <DialogContent>
                <Typography>
                  {/* Modifying this design order may require admin approval to approve. Do you want to proceed? */}
                  This design order was sent by the admin. 
                  Modifying it may require the admin to review and resend it for client approval. Do you want to proceed?
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setShowApprovalPopup(false)}>Cancel</Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    setShowApprovalPopup(false);
                    setIsClientEdited(true); // Mark it edited
                    formik.submitForm(); // Retry form submission
                  }}
                >
                  Proceed
                </Button>
              </DialogActions>
            </Dialog>
              <Dialog
                open={openHoldPopup}
                onClose={() => {
                  setOpenHoldPopup(false);
                  setHoldReason('');
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                BackdropProps={{ invisible: true }}
              >
                <DialogTitle id="alert-dialog-title">
                  {details?.hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {
                        details?.hold === 1
                          ? 'You want to move this Design Order from Hold.'
                          : 'You want to move this Design Order to Hold.'
                    }
                  </DialogContentText>
                  {(details?.hold === 0) ? (
                    <TextField
                      sx={{ width: 400 }}
                      label="Reason"
                      type="text"
                      multiline
                      minRows={3}
                      maxRows={7}
                      value={holdReason}
                      onChange={(e) => {
                        setHoldReason(e.target.value);
                        if (holdReasonError) setHoldReasonError('');
                      }}
                      error={Boolean(holdReasonError)}
                      helperText={holdReasonError}
                    />
                  ) : ''}
                </DialogContent>
                <DialogActions>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={async () => {
                      if ((details?.hold === 0) && !holdReason.trim()) {
                        setHoldReasonError(`Reason is required to put this Design Order on Hold`);
                        return;
                      }
                      setIsSubmittingHold(true);
                      handleUpdateHoldStatus(holdReason);
                      setIsSubmittingHold(false);
                      setOpenHoldPopup(false);
                      setHoldReason('');
                      setHoldReasonError('');
                    }}
                    disabled={isSubmittingHold}
                  >
                    {isSubmittingHold ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      'OK'
                    )}
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      setOpenHoldPopup(false);
                      setHoldReason('');
                    }}
                    sx={{ color: theme.palette.error.main }}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>

            {/* Recipe Modal for Adding Product Formula */}
            <Modal
              modalTitle="Add Product Formula"
              open={openRecipeModal}
              handleClose={() => setOpenRecipeModal(false)}
              width={1200}
            >
              <JobCost 
                fromSplitEstimate={true} 
                formulaName={formulaName}
                onRecipeCreated={handleRecipeCreated}
                setRecipes={setRecipes}
              />
            </Modal>

            {/* Catalog Modal for Adding Split Catalog Product */}
            <Modal
              modalTitle="Add Split Catalog Product"
              open={openCatalogModal}
              handleClose={() => setOpenCatalogModal(false)}
              width={1000}
            >
              <AddProducts 
                location={{
                  state: {
                    inhouse: 6, // Split catalog
                    selectedTab: 'split_catalog'
                  }
                }}
                fromSplitEstimate={true}
                onClose={() => {
                  setOpenCatalogModal(false);
                  // Refresh the split estimate details to update product_added status
                  fetchRequestDetails();
                }}
                productName={catalogProductName}
                RecipeId={catalogRecipeId}
                splitPercentageFromEstimate={splitPercentage}
                selectedRecipeId={selectedCatalogProductId}
                targetFacilityId = {details?.origin_facility_id}
              />
            </Modal>
            <SendDesignsEmailModal
              open={openEmailModal}
              onClose={() => setOpenEmailModal(false)}
              selectedDesigns={emailModalDesigns}
              designOrderId={details?.id}
              userId={user.user_id}
              userType={userType}
              onSuccess={handleEmailSent}
              isFromSplitEstimate={true}
            />
          </Container>
        )}
      </Page>
    )
  }
  
  const PrintFunction = forwardRef(
    ({ invoiceDate, details, invoice, data, selectedRecipes, splitServices, splitPercentage, productCost, installCost, serviceCost, totalCost }, ref) => {
      const theme = useTheme()
      const { COMPANY_LOGO, COMPANY_NAME } = useCompanyProfile()
      return (
        <Stack ref={ref}>
          <Grid container spacing={3} sx={{ position: 'relative' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', position: 'absolute', top: 0, left: 0, right: 0 }}>
              <Typography variant="h1" className="split-estimate-heading-print">Split Estimate</Typography>
            </Box>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                mb: 5,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <Box
                component="img"
                alt="logo"
                src={COMPANY_LOGO}
                id="logoImage"
                sx={{ height: 98, alignSelf: 'flex-start' }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                mb: 5,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
              }}
            >
              {/* <Typography variant="h1">Invoice from:</Typography> */}
              <Typography variant="h2">{COMPANY_NAME}</Typography>
              <Typography variant="h2">www.{COMPANY_NAME}.com</Typography>
              <Typography variant="h3">
                {data?.address}
                <br /> {data?.city}
                <br /> {data?.state}, {data?.zipcode}
              </Typography>
              {/* <Typography variant="h3">Telephone: +15208362947</Typography> */}
              <Typography variant="h3">Telephone: {data?.phone ? `+${data?.phone_country_code}${data?.phone}` : ''}</Typography>
            </Grid>
          </Grid>
  
          <Grid container spacing={2}>
            <Grid id="total1" item xs={12} sm={6}>
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                }}
              >
                <Box
                  id="order"
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    width: '100%',
                    maxWidth: '400px',
                  }}
                >
                  <Typography
                    id="discount1"
                    variant="h3"
                    style={{ textAlign: 'left', minWidth: '120px', marginRight: '10px' }}
                  >
                    Order date:
                  </Typography>
                  <Typography variant="h3" style={{ textAlign: 'left' }}>{invoiceDate}</Typography>
                </Box>
                <Box
                  id="title"
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    width: '100%',
                    maxWidth: '400px',
                  }}
                >
                  <Typography
                    id="discount1"
                    variant="h3"
                    style={{ textAlign: 'left', minWidth: '120px', marginRight: '10px' }}
                  >
                    Title:
                  </Typography>
                  <Typography variant="h3" style={{ textAlign: 'left' }}>{details?.name}</Typography>
                </Box>
                <Box
                  id="orderID"
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    width: '100%',
                    maxWidth: '400px',
                  }}
                >
                  <Typography
                    id="discount"
                    variant="h3"
                    style={{ textAlign: 'left', minWidth: '120px', marginRight: '10px' }}
                  >
                    Order ID:
                  </Typography>
                  <Typography variant="h3" style={{ textAlign: 'left' }}>{details?.id}</Typography>
                </Box>
                <Box
                  id="to"
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    width: '100%',
                    maxWidth: '400px',
                  }}
                >
                  <Typography id="totalmain1" variant="h3" style={{ minWidth: '120px', marginRight: '10px' }}>
                    To:
                  </Typography>
                  <Typography variant="h3" style={{ textAlign: 'left' }}>
                    {invoice?.customer_name}
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    width: '100%',
                    maxWidth: '400px',
                  }}
                >
                  <Typography id="totalmain1" variant="h3" style={{ minWidth: '120px', marginRight: '10px' }}>
                    Phone:
                  </Typography>
                  <Typography variant="h3" style={{ textAlign: 'left' }}>
                    {invoice?.customer_phone}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>

          {/* Product Formulas Table */}
          {selectedRecipes && selectedRecipes.length > 0 && (
            <>
              <Typography variant="h6" align="left" sx={{ mt: 3 }}>Product Formulas</Typography>
              <TableContainer component={Paper} sx={{ mt: 2 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Product</TableCell>
                      <TableCell>Formula</TableCell>
                      <TableCell>Outgoing Percentage</TableCell>
                      <TableCell>Actual Cost</TableCell>
                      <TableCell>Split Retail Cost</TableCell>
                      <TableCell>Total Cost</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedRecipes.map((data, index) => {
                      data.name = data?.name || data?.recipe_name
                      data.recipe_id = data?.recipe_id
                      
                      const expectedCost = data?.expected_cost || 0;
                      let expectedCostWithoutInstallLaborCost = expectedCost;
                      const safeSplitPercentage = splitPercentage || 0;
                      const splitAmount = expectedCostWithoutInstallLaborCost * (safeSplitPercentage / 100);
                      const rowTotalCost = parseFloat((expectedCost + splitAmount + (data?.expected_install_labor_cost || 0)).toFixed(2));
                      const lineTotalwithoutInstall = parseFloat((expectedCost + splitAmount).toFixed(2)); 
                      return (
                        <>
                          <TableRow key={index}>
                            <TableCell>{data?.product_name || '-'}</TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ 
                                maxWidth: 200, 
                                overflow: 'hidden', 
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}>
                                {(data?.name || '-').length > 30 ? `${(data?.name || '-').substring(0, 30)}...` : (data?.name || '-')}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {(safeSplitPercentage || 0)}%
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                ${(expectedCost).toFixed(2)}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                ${lineTotalwithoutInstall.toFixed(2)}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              {data?.expected_install_labor_cost && data?.expected_install_labor_cost > 0 ? (
                                <Typography variant="body2">
                                  -
                                </Typography>
                              ) : (
                                <Typography variant="body2">
                                  ${rowTotalCost.toFixed(2)}
                                </Typography>
                              )}
                            </TableCell>
                          </TableRow>
                          {data?.expected_install_labor_cost && data?.expected_install_labor_cost > 0 && (
                            <TableRow key={`install-${index}`}>
                              <TableCell>-</TableCell>
                              <TableCell>
                                <Typography variant="body2" sx={{color: "#1ccaff"}}>Install Labor Cost</Typography>
                              </TableCell>
                              <TableCell>-</TableCell>
                              <TableCell>
                                <Typography variant="body2">
                                  ${data?.expected_install_labor_cost.toFixed(2)}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2">
                                  ${data?.expected_install_labor_cost.toFixed(2)}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2">
                                  ${rowTotalCost.toFixed(2)}
                                </Typography>
                              </TableCell>
                            </TableRow>
                          )}
                          <TableRow>
                            <TableCell colSpan={6} sx={{ padding: 0 }}>
                              <Divider />
                            </TableCell>
                          </TableRow>
                        </>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}

          {/* Split Services Table */}
          {splitServices && splitServices.length > 0 && (
            <>
              <Typography variant="h6" align="left" sx={{ mt: 3 }}>Split Services</Typography>
              <TableContainer component={Paper} sx={{ mt: 2 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Service Name</TableCell>
                      <TableCell align="center">Unit Cost</TableCell>
                      <TableCell align="center">Quantity</TableCell>
                      <TableCell align="center">Total</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {splitServices.map((service, index) => (
                      <TableRow key={index}>
                        <TableCell>{service.name || '-'}</TableCell>
                        <TableCell align="center">
                          <Typography variant="body2">
                            ${(service.unit_cost || 0).toFixed(2)}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body2">
                            {service.quantity || 0}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body2">
                            ${(service.total || 0).toFixed(2)}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}

          {/* Totals Section */}
          <Box sx={{ mb: 2, marginRight: 2, mt: 1 }}>
            <Grid container spacing={1} sx={{ maxWidth: 400, ml: 'auto' }}>
              <Grid item xs={9}>
                <Typography variant="subtitle1" sx={{ textAlign: 'right', pt: 1 }}>
                  Total Product Cost :
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subtitle1" sx={{ textAlign: 'right', pt: 1 }}>
                  ${productCost.toFixed(2)}
                </Typography>
              </Grid>
              
              <Grid item xs={9}>
                <Typography variant="subtitle1" sx={{ textAlign: 'right', pt: 1 }}>
                  Total Installation Cost :
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subtitle1" sx={{ textAlign: 'right', pt: 1 }}>
                  ${installCost.toFixed(2)}
                </Typography>
              </Grid>
              {details?.isFromDesignOrder && (
                <>
                  <Grid item xs={9}>
                    <Typography variant="subtitle1" sx={{ textAlign: 'right', pt: 1 }}>
                      Total Service Cost :
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="subtitle1" sx={{ textAlign: 'right', pt: 1 }}>
                      ${serviceCost.toFixed(2)}
                    </Typography>
                  </Grid>
                </>
              )}
              
              <Grid item xs={9}>
                <Typography variant="subtitle1" sx={{ textAlign: 'right', fontWeight: 'bold', pt: 1 }}>
                  Grand Total Cost :
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subtitle1" sx={{ textAlign: 'right', fontWeight: 'bold', pt: 1 }}>
                  ${totalCost.toFixed(2)}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Stack>
      )
    },
  )
  